import { jsx as ut, Fragment as na } from "react/jsx-runtime";
import at, { createContext as $n, useContext as An, useMemo as ia, useState as aa, useEffect as wn, useRef as sa, useImperativeHandle as oa } from "react";
import { useLocation as ua, matchPath as ca, Route as fa } from "react-router-dom";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var y = function() {
  return y = Object.assign || function(e) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, y.apply(this, arguments);
};
function pa(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r)
    return r.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function ha(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r)
    return t;
  var n = r.call(t), i, a = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; )
      a.push(i.value);
  } catch (o) {
    s = { error: o };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return a;
}
function R() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t = t.concat(ha(arguments[e]));
  return t;
}
function la() {
  return typeof __SENTRY_BROWSER_BUNDLE__ < "u" && !!__SENTRY_BROWSER_BUNDLE__;
}
function be() {
  return !la() && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]";
}
function da(t, e) {
  return t.require(e);
}
var _a = {};
function F() {
  return be() ? global : typeof window < "u" ? window : typeof self < "u" ? self : _a;
}
function me(t, e, r) {
  var n = r || F(), i = n.__SENTRY__ = n.__SENTRY__ || {}, a = i[t] || (i[t] = e());
  return a;
}
var va = Object.prototype.toString;
function ga(t, e) {
  return va.call(t) === "[object " + e + "]";
}
function On(t) {
  return ga(t, "Object");
}
function Tn(t) {
  return Boolean(t && t.then && typeof t.then == "function");
}
var Cn = typeof __SENTRY_DEBUG__ > "u" ? !0 : __SENTRY_DEBUG__, ya = F(), ba = "Sentry Logger ", Zt = ["debug", "info", "warn", "error", "log", "assert"];
function jn(t) {
  var e = F();
  if (!("console" in e))
    return t();
  var r = e.console, n = {};
  Zt.forEach(function(i) {
    var a = r[i] && r[i].__sentry_original__;
    i in e.console && a && (n[i] = r[i], r[i] = a);
  });
  try {
    return t();
  } finally {
    Object.keys(n).forEach(function(i) {
      r[i] = n[i];
    });
  }
}
function We() {
  var t = !1, e = {
    enable: function() {
      t = !0;
    },
    disable: function() {
      t = !1;
    }
  };
  return Cn ? Zt.forEach(function(r) {
    e[r] = function() {
      for (var n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      t && jn(function() {
        var a;
        (a = ya.console)[r].apply(a, R([ba + "[" + r + "]:"], n));
      });
    };
  }) : Zt.forEach(function(r) {
    e[r] = function() {
    };
  }), e;
}
var gt;
Cn ? gt = me("logger", We) : gt = We();
function Jt(t) {
  var e, r;
  if (On(t)) {
    var n = {};
    try {
      for (var i = pa(Object.keys(t)), a = i.next(); !a.done; a = i.next()) {
        var s = a.value;
        typeof t[s] < "u" && (n[s] = Jt(t[s]));
      }
    } catch (o) {
      e = { error: o };
    } finally {
      try {
        a && !a.done && (r = i.return) && r.call(i);
      } finally {
        if (e)
          throw e.error;
      }
    }
    return n;
  }
  return Array.isArray(t) ? t.map(Jt) : t;
}
function st() {
  var t = F(), e = t.crypto || t.msCrypto;
  if (e !== void 0 && e.getRandomValues) {
    var r = new Uint16Array(8);
    e.getRandomValues(r), r[3] = r[3] & 4095 | 16384, r[4] = r[4] & 16383 | 32768;
    var n = function(i) {
      for (var a = i.toString(16); a.length < 4; )
        a = "0" + a;
      return a;
    };
    return n(r[0]) + n(r[1]) + n(r[2]) + n(r[3]) + n(r[4]) + n(r[5]) + n(r[6]) + n(r[7]);
  }
  return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(i) {
    var a = Math.random() * 16 | 0, s = i === "x" ? a : a & 3 | 8;
    return s.toString(16);
  });
}
var ma = function() {
  function t(e) {
    var r = this;
    this._state = 0, this._handlers = [], this._resolve = function(n) {
      r._setResult(1, n);
    }, this._reject = function(n) {
      r._setResult(2, n);
    }, this._setResult = function(n, i) {
      if (r._state === 0) {
        if (Tn(i)) {
          i.then(r._resolve, r._reject);
          return;
        }
        r._state = n, r._value = i, r._executeHandlers();
      }
    }, this._executeHandlers = function() {
      if (r._state !== 0) {
        var n = r._handlers.slice();
        r._handlers = [], n.forEach(function(i) {
          i[0] || (r._state === 1 && i[1](r._value), r._state === 2 && i[2](r._value), i[0] = !0);
        });
      }
    };
    try {
      e(this._resolve, this._reject);
    } catch (n) {
      this._reject(n);
    }
  }
  return t.prototype.then = function(e, r) {
    var n = this;
    return new t(function(i, a) {
      n._handlers.push([
        !1,
        function(s) {
          if (!e)
            i(s);
          else
            try {
              i(e(s));
            } catch (o) {
              a(o);
            }
        },
        function(s) {
          if (!r)
            a(s);
          else
            try {
              i(r(s));
            } catch (o) {
              a(o);
            }
        }
      ]), n._executeHandlers();
    });
  }, t.prototype.catch = function(e) {
    return this.then(function(r) {
      return r;
    }, e);
  }, t.prototype.finally = function(e) {
    var r = this;
    return new t(function(n, i) {
      var a, s;
      return r.then(function(o) {
        s = !1, a = o, e && e();
      }, function(o) {
        s = !0, a = o, e && e();
      }).then(function() {
        if (s) {
          i(a);
          return;
        }
        n(a);
      });
    });
  }, t;
}(), Xt = {
  nowSeconds: function() {
    return Date.now() / 1e3;
  }
};
function Sa() {
  var t = F().performance;
  if (!(!t || !t.now)) {
    var e = Date.now() - t.now();
    return {
      now: function() {
        return t.now();
      },
      timeOrigin: e
    };
  }
}
function xa() {
  try {
    var t = da(module, "perf_hooks");
    return t.performance;
  } catch {
    return;
  }
}
var Nt = be() ? xa() : Sa(), Ve = Nt === void 0 ? Xt : {
  nowSeconds: function() {
    return (Nt.timeOrigin + Nt.now()) / 1e3;
  }
}, Pn = Xt.nowSeconds.bind(Xt), Ze = Ve.nowSeconds.bind(Ve);
(function() {
  var t = F().performance;
  if (!(!t || !t.now)) {
    var e = 3600 * 1e3, r = t.now(), n = Date.now(), i = t.timeOrigin ? Math.abs(t.timeOrigin + r - n) : e, a = i < e, s = t.timing && t.timing.navigationStart, o = typeof s == "number", f = o ? Math.abs(s + r - n) : e, p = f < e;
    return a || p ? i <= f ? t.timeOrigin : s : n;
  }
})();
var Je = 100, Qt = function() {
  function t() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {};
  }
  return t.clone = function(e) {
    var r = new t();
    return e && (r._breadcrumbs = R(e._breadcrumbs), r._tags = y({}, e._tags), r._extra = y({}, e._extra), r._contexts = y({}, e._contexts), r._user = e._user, r._level = e._level, r._span = e._span, r._session = e._session, r._transactionName = e._transactionName, r._fingerprint = e._fingerprint, r._eventProcessors = R(e._eventProcessors), r._requestSession = e._requestSession), r;
  }, t.prototype.addScopeListener = function(e) {
    this._scopeListeners.push(e);
  }, t.prototype.addEventProcessor = function(e) {
    return this._eventProcessors.push(e), this;
  }, t.prototype.setUser = function(e) {
    return this._user = e || {}, this._session && this._session.update({ user: e }), this._notifyScopeListeners(), this;
  }, t.prototype.getUser = function() {
    return this._user;
  }, t.prototype.getRequestSession = function() {
    return this._requestSession;
  }, t.prototype.setRequestSession = function(e) {
    return this._requestSession = e, this;
  }, t.prototype.setTags = function(e) {
    return this._tags = y(y({}, this._tags), e), this._notifyScopeListeners(), this;
  }, t.prototype.setTag = function(e, r) {
    var n;
    return this._tags = y(y({}, this._tags), (n = {}, n[e] = r, n)), this._notifyScopeListeners(), this;
  }, t.prototype.setExtras = function(e) {
    return this._extra = y(y({}, this._extra), e), this._notifyScopeListeners(), this;
  }, t.prototype.setExtra = function(e, r) {
    var n;
    return this._extra = y(y({}, this._extra), (n = {}, n[e] = r, n)), this._notifyScopeListeners(), this;
  }, t.prototype.setFingerprint = function(e) {
    return this._fingerprint = e, this._notifyScopeListeners(), this;
  }, t.prototype.setLevel = function(e) {
    return this._level = e, this._notifyScopeListeners(), this;
  }, t.prototype.setTransactionName = function(e) {
    return this._transactionName = e, this._notifyScopeListeners(), this;
  }, t.prototype.setTransaction = function(e) {
    return this.setTransactionName(e);
  }, t.prototype.setContext = function(e, r) {
    var n;
    return r === null ? delete this._contexts[e] : this._contexts = y(y({}, this._contexts), (n = {}, n[e] = r, n)), this._notifyScopeListeners(), this;
  }, t.prototype.setSpan = function(e) {
    return this._span = e, this._notifyScopeListeners(), this;
  }, t.prototype.getSpan = function() {
    return this._span;
  }, t.prototype.getTransaction = function() {
    var e = this.getSpan();
    return e && e.transaction;
  }, t.prototype.setSession = function(e) {
    return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
  }, t.prototype.getSession = function() {
    return this._session;
  }, t.prototype.update = function(e) {
    if (!e)
      return this;
    if (typeof e == "function") {
      var r = e(this);
      return r instanceof t ? r : this;
    }
    return e instanceof t ? (this._tags = y(y({}, this._tags), e._tags), this._extra = y(y({}, this._extra), e._extra), this._contexts = y(y({}, this._contexts), e._contexts), e._user && Object.keys(e._user).length && (this._user = e._user), e._level && (this._level = e._level), e._fingerprint && (this._fingerprint = e._fingerprint), e._requestSession && (this._requestSession = e._requestSession)) : On(e) && (e = e, this._tags = y(y({}, this._tags), e.tags), this._extra = y(y({}, this._extra), e.extra), this._contexts = y(y({}, this._contexts), e.contexts), e.user && (this._user = e.user), e.level && (this._level = e.level), e.fingerprint && (this._fingerprint = e.fingerprint), e.requestSession && (this._requestSession = e.requestSession)), this;
  }, t.prototype.clear = function() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._span = void 0, this._session = void 0, this._notifyScopeListeners(), this;
  }, t.prototype.addBreadcrumb = function(e, r) {
    var n = typeof r == "number" ? Math.min(r, Je) : Je;
    if (n <= 0)
      return this;
    var i = y({ timestamp: Pn() }, e);
    return this._breadcrumbs = R(this._breadcrumbs, [i]).slice(-n), this._notifyScopeListeners(), this;
  }, t.prototype.clearBreadcrumbs = function() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }, t.prototype.applyToEvent = function(e, r) {
    if (this._extra && Object.keys(this._extra).length && (e.extra = y(y({}, this._extra), e.extra)), this._tags && Object.keys(this._tags).length && (e.tags = y(y({}, this._tags), e.tags)), this._user && Object.keys(this._user).length && (e.user = y(y({}, this._user), e.user)), this._contexts && Object.keys(this._contexts).length && (e.contexts = y(y({}, this._contexts), e.contexts)), this._level && (e.level = this._level), this._transactionName && (e.transaction = this._transactionName), this._span) {
      e.contexts = y({ trace: this._span.getTraceContext() }, e.contexts);
      var n = this._span.transaction && this._span.transaction.name;
      n && (e.tags = y({ transaction: n }, e.tags));
    }
    return this._applyFingerprint(e), e.breadcrumbs = R(e.breadcrumbs || [], this._breadcrumbs), e.breadcrumbs = e.breadcrumbs.length > 0 ? e.breadcrumbs : void 0, e.sdkProcessingMetadata = this._sdkProcessingMetadata, this._notifyEventProcessors(R(Ea(), this._eventProcessors), e, r);
  }, t.prototype.setSDKProcessingMetadata = function(e) {
    return this._sdkProcessingMetadata = y(y({}, this._sdkProcessingMetadata), e), this;
  }, t.prototype._notifyEventProcessors = function(e, r, n, i) {
    var a = this;
    return i === void 0 && (i = 0), new ma(function(s, o) {
      var f = e[i];
      if (r === null || typeof f != "function")
        s(r);
      else {
        var p = f(y({}, r), n);
        Tn(p) ? p.then(function(d) {
          return a._notifyEventProcessors(e, d, n, i + 1).then(s);
        }).then(null, o) : a._notifyEventProcessors(e, p, n, i + 1).then(s).then(null, o);
      }
    });
  }, t.prototype._notifyScopeListeners = function() {
    var e = this;
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach(function(r) {
      r(e);
    }), this._notifyingListeners = !1);
  }, t.prototype._applyFingerprint = function(e) {
    e.fingerprint = e.fingerprint ? Array.isArray(e.fingerprint) ? e.fingerprint : [e.fingerprint] : [], this._fingerprint && (e.fingerprint = e.fingerprint.concat(this._fingerprint)), e.fingerprint && !e.fingerprint.length && delete e.fingerprint;
  }, t;
}();
function Ea() {
  return me("globalEventProcessors", function() {
    return [];
  });
}
var $a = function() {
  function t(e) {
    this.errors = 0, this.sid = st(), this.duration = 0, this.status = "ok", this.init = !0, this.ignoreDuration = !1;
    var r = Ze();
    this.timestamp = r, this.started = r, e && this.update(e);
  }
  return t.prototype.update = function(e) {
    if (e === void 0 && (e = {}), e.user && (!this.ipAddress && e.user.ip_address && (this.ipAddress = e.user.ip_address), !this.did && !e.did && (this.did = e.user.id || e.user.email || e.user.username)), this.timestamp = e.timestamp || Ze(), e.ignoreDuration && (this.ignoreDuration = e.ignoreDuration), e.sid && (this.sid = e.sid.length === 32 ? e.sid : st()), e.init !== void 0 && (this.init = e.init), !this.did && e.did && (this.did = "" + e.did), typeof e.started == "number" && (this.started = e.started), this.ignoreDuration)
      this.duration = void 0;
    else if (typeof e.duration == "number")
      this.duration = e.duration;
    else {
      var r = this.timestamp - this.started;
      this.duration = r >= 0 ? r : 0;
    }
    e.release && (this.release = e.release), e.environment && (this.environment = e.environment), !this.ipAddress && e.ipAddress && (this.ipAddress = e.ipAddress), !this.userAgent && e.userAgent && (this.userAgent = e.userAgent), typeof e.errors == "number" && (this.errors = e.errors), e.status && (this.status = e.status);
  }, t.prototype.close = function(e) {
    e ? this.update({ status: e }) : this.status === "ok" ? this.update({ status: "exited" }) : this.update();
  }, t.prototype.toJSON = function() {
    return Jt({
      sid: "" + this.sid,
      init: this.init,
      started: new Date(this.started * 1e3).toISOString(),
      timestamp: new Date(this.timestamp * 1e3).toISOString(),
      status: this.status,
      errors: this.errors,
      did: typeof this.did == "number" || typeof this.did == "string" ? "" + this.did : void 0,
      duration: this.duration,
      attrs: {
        release: this.release,
        environment: this.environment,
        ip_address: this.ipAddress,
        user_agent: this.userAgent
      }
    });
  }, t;
}(), Xe = typeof __SENTRY_DEBUG__ > "u" ? !0 : __SENTRY_DEBUG__, Se = 4, Aa = 100, xe = function() {
  function t(e, r, n) {
    r === void 0 && (r = new Qt()), n === void 0 && (n = Se), this._version = n, this._stack = [{}], this.getStackTop().scope = r, e && this.bindClient(e);
  }
  return t.prototype.isOlderThan = function(e) {
    return this._version < e;
  }, t.prototype.bindClient = function(e) {
    var r = this.getStackTop();
    r.client = e, e && e.setupIntegrations && e.setupIntegrations();
  }, t.prototype.pushScope = function() {
    var e = Qt.clone(this.getScope());
    return this.getStack().push({
      client: this.getClient(),
      scope: e
    }), e;
  }, t.prototype.popScope = function() {
    return this.getStack().length <= 1 ? !1 : !!this.getStack().pop();
  }, t.prototype.withScope = function(e) {
    var r = this.pushScope();
    try {
      e(r);
    } finally {
      this.popScope();
    }
  }, t.prototype.getClient = function() {
    return this.getStackTop().client;
  }, t.prototype.getScope = function() {
    return this.getStackTop().scope;
  }, t.prototype.getStack = function() {
    return this._stack;
  }, t.prototype.getStackTop = function() {
    return this._stack[this._stack.length - 1];
  }, t.prototype.captureException = function(e, r) {
    var n = this._lastEventId = r && r.event_id ? r.event_id : st(), i = r;
    if (!r) {
      var a = void 0;
      try {
        throw new Error("Sentry syntheticException");
      } catch (s) {
        a = s;
      }
      i = {
        originalException: e,
        syntheticException: a
      };
    }
    return this._invokeClient("captureException", e, y(y({}, i), { event_id: n })), n;
  }, t.prototype.captureMessage = function(e, r, n) {
    var i = this._lastEventId = n && n.event_id ? n.event_id : st(), a = n;
    if (!n) {
      var s = void 0;
      try {
        throw new Error(e);
      } catch (o) {
        s = o;
      }
      a = {
        originalException: e,
        syntheticException: s
      };
    }
    return this._invokeClient("captureMessage", e, r, y(y({}, a), { event_id: i })), i;
  }, t.prototype.captureEvent = function(e, r) {
    var n = r && r.event_id ? r.event_id : st();
    return e.type !== "transaction" && (this._lastEventId = n), this._invokeClient("captureEvent", e, y(y({}, r), { event_id: n })), n;
  }, t.prototype.lastEventId = function() {
    return this._lastEventId;
  }, t.prototype.addBreadcrumb = function(e, r) {
    var n = this.getStackTop(), i = n.scope, a = n.client;
    if (!(!i || !a)) {
      var s = a.getOptions && a.getOptions() || {}, o = s.beforeBreadcrumb, f = o === void 0 ? null : o, p = s.maxBreadcrumbs, d = p === void 0 ? Aa : p;
      if (!(d <= 0)) {
        var _ = Pn(), g = y({ timestamp: _ }, e), S = f ? jn(function() {
          return f(g, r);
        }) : g;
        S !== null && i.addBreadcrumb(S, d);
      }
    }
  }, t.prototype.setUser = function(e) {
    var r = this.getScope();
    r && r.setUser(e);
  }, t.prototype.setTags = function(e) {
    var r = this.getScope();
    r && r.setTags(e);
  }, t.prototype.setExtras = function(e) {
    var r = this.getScope();
    r && r.setExtras(e);
  }, t.prototype.setTag = function(e, r) {
    var n = this.getScope();
    n && n.setTag(e, r);
  }, t.prototype.setExtra = function(e, r) {
    var n = this.getScope();
    n && n.setExtra(e, r);
  }, t.prototype.setContext = function(e, r) {
    var n = this.getScope();
    n && n.setContext(e, r);
  }, t.prototype.configureScope = function(e) {
    var r = this.getStackTop(), n = r.scope, i = r.client;
    n && i && e(n);
  }, t.prototype.run = function(e) {
    var r = Qe(this);
    try {
      e(this);
    } finally {
      Qe(r);
    }
  }, t.prototype.getIntegration = function(e) {
    var r = this.getClient();
    if (!r)
      return null;
    try {
      return r.getIntegration(e);
    } catch {
      return Xe && gt.warn("Cannot retrieve integration " + e.id + " from the current Hub"), null;
    }
  }, t.prototype.startSpan = function(e) {
    return this._callExtensionMethod("startSpan", e);
  }, t.prototype.startTransaction = function(e, r) {
    return this._callExtensionMethod("startTransaction", e, r);
  }, t.prototype.traceHeaders = function() {
    return this._callExtensionMethod("traceHeaders");
  }, t.prototype.captureSession = function(e) {
    if (e === void 0 && (e = !1), e)
      return this.endSession();
    this._sendSessionUpdate();
  }, t.prototype.endSession = function() {
    var e = this.getStackTop(), r = e && e.scope, n = r && r.getSession();
    n && n.close(), this._sendSessionUpdate(), r && r.setSession();
  }, t.prototype.startSession = function(e) {
    var r = this.getStackTop(), n = r.scope, i = r.client, a = i && i.getOptions() || {}, s = a.release, o = a.environment, f = F(), p = (f.navigator || {}).userAgent, d = new $a(y(y(y({
      release: s,
      environment: o
    }, n && { user: n.getUser() }), p && { userAgent: p }), e));
    if (n) {
      var _ = n.getSession && n.getSession();
      _ && _.status === "ok" && _.update({ status: "exited" }), this.endSession(), n.setSession(d);
    }
    return d;
  }, t.prototype._sendSessionUpdate = function() {
    var e = this.getStackTop(), r = e.scope, n = e.client;
    if (!!r) {
      var i = r.getSession && r.getSession();
      i && n && n.captureSession && n.captureSession(i);
    }
  }, t.prototype._invokeClient = function(e) {
    for (var r, n = [], i = 1; i < arguments.length; i++)
      n[i - 1] = arguments[i];
    var a = this.getStackTop(), s = a.scope, o = a.client;
    o && o[e] && (r = o)[e].apply(r, R(n, [s]));
  }, t.prototype._callExtensionMethod = function(e) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    var i = Et(), a = i.__SENTRY__;
    if (a && a.extensions && typeof a.extensions[e] == "function")
      return a.extensions[e].apply(this, r);
    Xe && gt.warn("Extension method " + e + " couldn't be found, doing nothing.");
  }, t;
}();
function Et() {
  var t = F();
  return t.__SENTRY__ = t.__SENTRY__ || {
    extensions: {},
    hub: void 0
  }, t;
}
function Qe(t) {
  var e = Et(), r = I(e);
  return Ee(e, t), r;
}
function wa() {
  var t = Et();
  return (!Rn(t) || I(t).isOlderThan(Se)) && Ee(t, new xe()), be() ? Oa(t) : I(t);
}
function Oa(t) {
  try {
    var e = Et().__SENTRY__, r = e && e.extensions && e.extensions.domain && e.extensions.domain.active;
    if (!r)
      return I(t);
    if (!Rn(r) || I(r).isOlderThan(Se)) {
      var n = I(t).getStackTop();
      Ee(r, new xe(n.client, Qt.clone(n.scope)));
    }
    return I(r);
  } catch {
    return I(t);
  }
}
function Rn(t) {
  return !!(t && t.__SENTRY__ && t.__SENTRY__.hub);
}
function I(t) {
  return me("hub", function() {
    return new xe();
  }, t);
}
function Ee(t, e) {
  if (!t)
    return !1;
  var r = t.__SENTRY__ = t.__SENTRY__ || {};
  return r.hub = e, !0;
}
function $e(t) {
  for (var e = [], r = 1; r < arguments.length; r++)
    e[r - 1] = arguments[r];
  var n = wa();
  if (n && n[t])
    return n[t].apply(n, R(e));
  throw new Error("No hub defined or " + t + " was not found on the hub, please open a bug report.");
}
function Ta(t, e) {
  var r = new Error("Sentry syntheticException");
  return $e("captureException", t, {
    captureContext: e,
    originalException: t,
    syntheticException: r
  });
}
function Ca(t, e) {
  var r = new Error(t), n = typeof e == "string" ? e : void 0, i = typeof e != "string" ? { captureContext: e } : void 0;
  return $e("captureMessage", t, n, y({ originalException: t, syntheticException: r }, i));
}
function In(t) {
  $e("withScope", t);
}
var te;
(function(t) {
  t.Fatal = "fatal", t.Error = "error", t.Warning = "warning", t.Log = "log", t.Info = "info", t.Debug = "debug", t.Critical = "critical";
})(te || (te = {}));
var lt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ja(t, e, r, n) {
  var i = -1, a = t == null ? 0 : t.length;
  for (n && a && (r = t[++i]); ++i < a; )
    r = e(r, t[i], i, t);
  return r;
}
var Pa = ja;
function Ra(t) {
  return function(e) {
    return t == null ? void 0 : t[e];
  };
}
var Ia = Ra, Da = Ia, La = {
  \u00C0: "A",
  \u00C1: "A",
  \u00C2: "A",
  \u00C3: "A",
  \u00C4: "A",
  \u00C5: "A",
  \u00E0: "a",
  \u00E1: "a",
  \u00E2: "a",
  \u00E3: "a",
  \u00E4: "a",
  \u00E5: "a",
  \u00C7: "C",
  \u00E7: "c",
  \u00D0: "D",
  \u00F0: "d",
  \u00C8: "E",
  \u00C9: "E",
  \u00CA: "E",
  \u00CB: "E",
  \u00E8: "e",
  \u00E9: "e",
  \u00EA: "e",
  \u00EB: "e",
  \u00CC: "I",
  \u00CD: "I",
  \u00CE: "I",
  \u00CF: "I",
  \u00EC: "i",
  \u00ED: "i",
  \u00EE: "i",
  \u00EF: "i",
  \u00D1: "N",
  \u00F1: "n",
  \u00D2: "O",
  \u00D3: "O",
  \u00D4: "O",
  \u00D5: "O",
  \u00D6: "O",
  \u00D8: "O",
  \u00F2: "o",
  \u00F3: "o",
  \u00F4: "o",
  \u00F5: "o",
  \u00F6: "o",
  \u00F8: "o",
  \u00D9: "U",
  \u00DA: "U",
  \u00DB: "U",
  \u00DC: "U",
  \u00F9: "u",
  \u00FA: "u",
  \u00FB: "u",
  \u00FC: "u",
  \u00DD: "Y",
  \u00FD: "y",
  \u00FF: "y",
  \u00C6: "Ae",
  \u00E6: "ae",
  \u00DE: "Th",
  \u00FE: "th",
  \u00DF: "ss",
  \u0100: "A",
  \u0102: "A",
  \u0104: "A",
  \u0101: "a",
  \u0103: "a",
  \u0105: "a",
  \u0106: "C",
  \u0108: "C",
  \u010A: "C",
  \u010C: "C",
  \u0107: "c",
  \u0109: "c",
  \u010B: "c",
  \u010D: "c",
  \u010E: "D",
  \u0110: "D",
  \u010F: "d",
  \u0111: "d",
  \u0112: "E",
  \u0114: "E",
  \u0116: "E",
  \u0118: "E",
  \u011A: "E",
  \u0113: "e",
  \u0115: "e",
  \u0117: "e",
  \u0119: "e",
  \u011B: "e",
  \u011C: "G",
  \u011E: "G",
  \u0120: "G",
  \u0122: "G",
  \u011D: "g",
  \u011F: "g",
  \u0121: "g",
  \u0123: "g",
  \u0124: "H",
  \u0126: "H",
  \u0125: "h",
  \u0127: "h",
  \u0128: "I",
  \u012A: "I",
  \u012C: "I",
  \u012E: "I",
  \u0130: "I",
  \u0129: "i",
  \u012B: "i",
  \u012D: "i",
  \u012F: "i",
  \u0131: "i",
  \u0134: "J",
  \u0135: "j",
  \u0136: "K",
  \u0137: "k",
  \u0138: "k",
  \u0139: "L",
  \u013B: "L",
  \u013D: "L",
  \u013F: "L",
  \u0141: "L",
  \u013A: "l",
  \u013C: "l",
  \u013E: "l",
  \u0140: "l",
  \u0142: "l",
  \u0143: "N",
  \u0145: "N",
  \u0147: "N",
  \u014A: "N",
  \u0144: "n",
  \u0146: "n",
  \u0148: "n",
  \u014B: "n",
  \u014C: "O",
  \u014E: "O",
  \u0150: "O",
  \u014D: "o",
  \u014F: "o",
  \u0151: "o",
  \u0154: "R",
  \u0156: "R",
  \u0158: "R",
  \u0155: "r",
  \u0157: "r",
  \u0159: "r",
  \u015A: "S",
  \u015C: "S",
  \u015E: "S",
  \u0160: "S",
  \u015B: "s",
  \u015D: "s",
  \u015F: "s",
  \u0161: "s",
  \u0162: "T",
  \u0164: "T",
  \u0166: "T",
  \u0163: "t",
  \u0165: "t",
  \u0167: "t",
  \u0168: "U",
  \u016A: "U",
  \u016C: "U",
  \u016E: "U",
  \u0170: "U",
  \u0172: "U",
  \u0169: "u",
  \u016B: "u",
  \u016D: "u",
  \u016F: "u",
  \u0171: "u",
  \u0173: "u",
  \u0174: "W",
  \u0175: "w",
  \u0176: "Y",
  \u0177: "y",
  \u0178: "Y",
  \u0179: "Z",
  \u017B: "Z",
  \u017D: "Z",
  \u017A: "z",
  \u017C: "z",
  \u017E: "z",
  \u0132: "IJ",
  \u0133: "ij",
  \u0152: "Oe",
  \u0153: "oe",
  \u0149: "'n",
  \u017F: "s"
}, Fa = Da(La), Na = Fa, Ma = typeof lt == "object" && lt && lt.Object === Object && lt, Dn = Ma, ka = Dn, Ua = typeof self == "object" && self && self.Object === Object && self, Ba = ka || Ua || Function("return this")(), j = Ba, Ga = j, za = Ga.Symbol, $t = za;
function Ha(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, i = Array(n); ++r < n; )
    i[r] = e(t[r], r, t);
  return i;
}
var qa = Ha, Ya = Array.isArray, N = Ya, tr = $t, Ln = Object.prototype, Ka = Ln.hasOwnProperty, Wa = Ln.toString, nt = tr ? tr.toStringTag : void 0;
function Va(t) {
  var e = Ka.call(t, nt), r = t[nt];
  try {
    t[nt] = void 0;
    var n = !0;
  } catch {
  }
  var i = Wa.call(t);
  return n && (e ? t[nt] = r : delete t[nt]), i;
}
var Za = Va, Ja = Object.prototype, Xa = Ja.toString;
function Qa(t) {
  return Xa.call(t);
}
var ts = Qa, er = $t, es = Za, rs = ts, ns = "[object Null]", is = "[object Undefined]", rr = er ? er.toStringTag : void 0;
function as(t) {
  return t == null ? t === void 0 ? is : ns : rr && rr in Object(t) ? es(t) : rs(t);
}
var ct = as;
function ss(t) {
  return t != null && typeof t == "object";
}
var ft = ss, os = ct, us = ft, cs = "[object Symbol]";
function fs(t) {
  return typeof t == "symbol" || us(t) && os(t) == cs;
}
var Ae = fs, nr = $t, ps = qa, hs = N, ls = Ae, ds = 1 / 0, ir = nr ? nr.prototype : void 0, ar = ir ? ir.toString : void 0;
function Fn(t) {
  if (typeof t == "string")
    return t;
  if (hs(t))
    return ps(t, Fn) + "";
  if (ls(t))
    return ar ? ar.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -ds ? "-0" : e;
}
var _s = Fn, vs = _s;
function gs(t) {
  return t == null ? "" : vs(t);
}
var we = gs, ys = Na, bs = we, ms = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Ss = "\\u0300-\\u036f", xs = "\\ufe20-\\ufe2f", Es = "\\u20d0-\\u20ff", $s = Ss + xs + Es, As = "[" + $s + "]", ws = RegExp(As, "g");
function Os(t) {
  return t = bs(t), t && t.replace(ms, ys).replace(ws, "");
}
var Ts = Os, Cs = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function js(t) {
  return t.match(Cs) || [];
}
var Ps = js, Rs = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function Is(t) {
  return Rs.test(t);
}
var Ds = Is, Nn = "\\ud800-\\udfff", Ls = "\\u0300-\\u036f", Fs = "\\ufe20-\\ufe2f", Ns = "\\u20d0-\\u20ff", Ms = Ls + Fs + Ns, Mn = "\\u2700-\\u27bf", kn = "a-z\\xdf-\\xf6\\xf8-\\xff", ks = "\\xac\\xb1\\xd7\\xf7", Us = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Bs = "\\u2000-\\u206f", Gs = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Un = "A-Z\\xc0-\\xd6\\xd8-\\xde", zs = "\\ufe0e\\ufe0f", Bn = ks + Us + Bs + Gs, Gn = "['\u2019]", sr = "[" + Bn + "]", Hs = "[" + Ms + "]", zn = "\\d+", qs = "[" + Mn + "]", Hn = "[" + kn + "]", qn = "[^" + Nn + Bn + zn + Mn + kn + Un + "]", Ys = "\\ud83c[\\udffb-\\udfff]", Ks = "(?:" + Hs + "|" + Ys + ")", Ws = "[^" + Nn + "]", Yn = "(?:\\ud83c[\\udde6-\\uddff]){2}", Kn = "[\\ud800-\\udbff][\\udc00-\\udfff]", q = "[" + Un + "]", Vs = "\\u200d", or = "(?:" + Hn + "|" + qn + ")", Zs = "(?:" + q + "|" + qn + ")", ur = "(?:" + Gn + "(?:d|ll|m|re|s|t|ve))?", cr = "(?:" + Gn + "(?:D|LL|M|RE|S|T|VE))?", Wn = Ks + "?", Vn = "[" + zs + "]?", Js = "(?:" + Vs + "(?:" + [Ws, Yn, Kn].join("|") + ")" + Vn + Wn + ")*", Xs = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Qs = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", to = Vn + Wn + Js, eo = "(?:" + [qs, Yn, Kn].join("|") + ")" + to, ro = RegExp([
  q + "?" + Hn + "+" + ur + "(?=" + [sr, q, "$"].join("|") + ")",
  Zs + "+" + cr + "(?=" + [sr, q + or, "$"].join("|") + ")",
  q + "?" + or + "+" + ur,
  q + "+" + cr,
  Qs,
  Xs,
  zn,
  eo
].join("|"), "g");
function no(t) {
  return t.match(ro) || [];
}
var io = no, ao = Ps, so = Ds, oo = we, uo = io;
function co(t, e, r) {
  return t = oo(t), e = r ? void 0 : e, e === void 0 ? so(t) ? uo(t) : ao(t) : t.match(e) || [];
}
var fo = co, po = Pa, ho = Ts, lo = fo, _o = "['\u2019]", vo = RegExp(_o, "g");
function go(t) {
  return function(e) {
    return po(lo(ho(e).replace(vo, "")), t, "");
  };
}
var yo = go, bo = yo, mo = bo(function(t, e, r) {
  return t + (r ? "_" : "") + e.toLowerCase();
}), Mt = mo;
function So(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Oe = So, xo = ct, Eo = Oe, $o = "[object AsyncFunction]", Ao = "[object Function]", wo = "[object GeneratorFunction]", Oo = "[object Proxy]";
function To(t) {
  if (!Eo(t))
    return !1;
  var e = xo(t);
  return e == Ao || e == wo || e == $o || e == Oo;
}
var Zn = To, Co = j, jo = Co["__core-js_shared__"], Po = jo, kt = Po, fr = function() {
  var t = /[^.]+$/.exec(kt && kt.keys && kt.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function Ro(t) {
  return !!fr && fr in t;
}
var Io = Ro, Do = Function.prototype, Lo = Do.toString;
function Fo(t) {
  if (t != null) {
    try {
      return Lo.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var Jn = Fo, No = Zn, Mo = Io, ko = Oe, Uo = Jn, Bo = /[\\^$.*+?()[\]{}|]/g, Go = /^\[object .+?Constructor\]$/, zo = Function.prototype, Ho = Object.prototype, qo = zo.toString, Yo = Ho.hasOwnProperty, Ko = RegExp(
  "^" + qo.call(Yo).replace(Bo, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Wo(t) {
  if (!ko(t) || Mo(t))
    return !1;
  var e = No(t) ? Ko : Go;
  return e.test(Uo(t));
}
var Vo = Wo;
function Zo(t, e) {
  return t == null ? void 0 : t[e];
}
var Jo = Zo, Xo = Vo, Qo = Jo;
function tu(t, e) {
  var r = Qo(t, e);
  return Xo(r) ? r : void 0;
}
var z = tu, eu = z, ru = function() {
  try {
    var t = eu(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), nu = ru, pr = nu;
function iu(t, e, r) {
  e == "__proto__" && pr ? pr(t, e, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : t[e] = r;
}
var au = iu;
function su(t) {
  return function(e, r, n) {
    for (var i = -1, a = Object(e), s = n(e), o = s.length; o--; ) {
      var f = s[t ? o : ++i];
      if (r(a[f], f, a) === !1)
        break;
    }
    return e;
  };
}
var ou = su, uu = ou, cu = uu(), fu = cu;
function pu(t, e) {
  for (var r = -1, n = Array(t); ++r < t; )
    n[r] = e(r);
  return n;
}
var hu = pu, lu = ct, du = ft, _u = "[object Arguments]";
function vu(t) {
  return du(t) && lu(t) == _u;
}
var gu = vu, hr = gu, yu = ft, Xn = Object.prototype, bu = Xn.hasOwnProperty, mu = Xn.propertyIsEnumerable, Su = hr(function() {
  return arguments;
}()) ? hr : function(t) {
  return yu(t) && bu.call(t, "callee") && !mu.call(t, "callee");
}, Qn = Su, yt = { exports: {} };
function xu() {
  return !1;
}
var Eu = xu;
(function(t, e) {
  var r = j, n = Eu, i = e && !e.nodeType && e, a = i && !0 && t && !t.nodeType && t, s = a && a.exports === i, o = s ? r.Buffer : void 0, f = o ? o.isBuffer : void 0, p = f || n;
  t.exports = p;
})(yt, yt.exports);
var $u = 9007199254740991, Au = /^(?:0|[1-9]\d*)$/;
function wu(t, e) {
  var r = typeof t;
  return e = e == null ? $u : e, !!e && (r == "number" || r != "symbol" && Au.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var ti = wu, Ou = 9007199254740991;
function Tu(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= Ou;
}
var Te = Tu, Cu = ct, ju = Te, Pu = ft, Ru = "[object Arguments]", Iu = "[object Array]", Du = "[object Boolean]", Lu = "[object Date]", Fu = "[object Error]", Nu = "[object Function]", Mu = "[object Map]", ku = "[object Number]", Uu = "[object Object]", Bu = "[object RegExp]", Gu = "[object Set]", zu = "[object String]", Hu = "[object WeakMap]", qu = "[object ArrayBuffer]", Yu = "[object DataView]", Ku = "[object Float32Array]", Wu = "[object Float64Array]", Vu = "[object Int8Array]", Zu = "[object Int16Array]", Ju = "[object Int32Array]", Xu = "[object Uint8Array]", Qu = "[object Uint8ClampedArray]", tc = "[object Uint16Array]", ec = "[object Uint32Array]", A = {};
A[Ku] = A[Wu] = A[Vu] = A[Zu] = A[Ju] = A[Xu] = A[Qu] = A[tc] = A[ec] = !0;
A[Ru] = A[Iu] = A[qu] = A[Du] = A[Yu] = A[Lu] = A[Fu] = A[Nu] = A[Mu] = A[ku] = A[Uu] = A[Bu] = A[Gu] = A[zu] = A[Hu] = !1;
function rc(t) {
  return Pu(t) && ju(t.length) && !!A[Cu(t)];
}
var nc = rc;
function ic(t) {
  return function(e) {
    return t(e);
  };
}
var ac = ic, ee = { exports: {} };
(function(t, e) {
  var r = Dn, n = e && !e.nodeType && e, i = n && !0 && t && !t.nodeType && t, a = i && i.exports === n, s = a && r.process, o = function() {
    try {
      var f = i && i.require && i.require("util").types;
      return f || s && s.binding && s.binding("util");
    } catch {
    }
  }();
  t.exports = o;
})(ee, ee.exports);
var sc = nc, oc = ac, lr = ee.exports, dr = lr && lr.isTypedArray, uc = dr ? oc(dr) : sc, ei = uc, cc = hu, fc = Qn, pc = N, hc = yt.exports, lc = ti, dc = ei, _c = Object.prototype, vc = _c.hasOwnProperty;
function gc(t, e) {
  var r = pc(t), n = !r && fc(t), i = !r && !n && hc(t), a = !r && !n && !i && dc(t), s = r || n || i || a, o = s ? cc(t.length, String) : [], f = o.length;
  for (var p in t)
    (e || vc.call(t, p)) && !(s && (p == "length" || i && (p == "offset" || p == "parent") || a && (p == "buffer" || p == "byteLength" || p == "byteOffset") || lc(p, f))) && o.push(p);
  return o;
}
var yc = gc, bc = Object.prototype;
function mc(t) {
  var e = t && t.constructor, r = typeof e == "function" && e.prototype || bc;
  return t === r;
}
var Sc = mc;
function xc(t, e) {
  return function(r) {
    return t(e(r));
  };
}
var Ec = xc, $c = Ec, Ac = $c(Object.keys, Object), wc = Ac, Oc = Sc, Tc = wc, Cc = Object.prototype, jc = Cc.hasOwnProperty;
function Pc(t) {
  if (!Oc(t))
    return Tc(t);
  var e = [];
  for (var r in Object(t))
    jc.call(t, r) && r != "constructor" && e.push(r);
  return e;
}
var Rc = Pc, Ic = Zn, Dc = Te;
function Lc(t) {
  return t != null && Dc(t.length) && !Ic(t);
}
var Fc = Lc, Nc = yc, Mc = Rc, kc = Fc;
function Uc(t) {
  return kc(t) ? Nc(t) : Mc(t);
}
var Ce = Uc, Bc = fu, Gc = Ce;
function zc(t, e) {
  return t && Bc(t, e, Gc);
}
var Hc = zc;
function qc() {
  this.__data__ = [], this.size = 0;
}
var Yc = qc;
function Kc(t, e) {
  return t === e || t !== t && e !== e;
}
var ri = Kc, Wc = ri;
function Vc(t, e) {
  for (var r = t.length; r--; )
    if (Wc(t[r][0], e))
      return r;
  return -1;
}
var At = Vc, Zc = At, Jc = Array.prototype, Xc = Jc.splice;
function Qc(t) {
  var e = this.__data__, r = Zc(e, t);
  if (r < 0)
    return !1;
  var n = e.length - 1;
  return r == n ? e.pop() : Xc.call(e, r, 1), --this.size, !0;
}
var tf = Qc, ef = At;
function rf(t) {
  var e = this.__data__, r = ef(e, t);
  return r < 0 ? void 0 : e[r][1];
}
var nf = rf, af = At;
function sf(t) {
  return af(this.__data__, t) > -1;
}
var of = sf, uf = At;
function cf(t, e) {
  var r = this.__data__, n = uf(r, t);
  return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
}
var ff = cf, pf = Yc, hf = tf, lf = nf, df = of, _f = ff;
function K(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
K.prototype.clear = pf;
K.prototype.delete = hf;
K.prototype.get = lf;
K.prototype.has = df;
K.prototype.set = _f;
var wt = K, vf = wt;
function gf() {
  this.__data__ = new vf(), this.size = 0;
}
var yf = gf;
function bf(t) {
  var e = this.__data__, r = e.delete(t);
  return this.size = e.size, r;
}
var mf = bf;
function Sf(t) {
  return this.__data__.get(t);
}
var xf = Sf;
function Ef(t) {
  return this.__data__.has(t);
}
var $f = Ef, Af = z, wf = j, Of = Af(wf, "Map"), je = Of, Tf = z, Cf = Tf(Object, "create"), Ot = Cf, _r = Ot;
function jf() {
  this.__data__ = _r ? _r(null) : {}, this.size = 0;
}
var Pf = jf;
function Rf(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var If = Rf, Df = Ot, Lf = "__lodash_hash_undefined__", Ff = Object.prototype, Nf = Ff.hasOwnProperty;
function Mf(t) {
  var e = this.__data__;
  if (Df) {
    var r = e[t];
    return r === Lf ? void 0 : r;
  }
  return Nf.call(e, t) ? e[t] : void 0;
}
var kf = Mf, Uf = Ot, Bf = Object.prototype, Gf = Bf.hasOwnProperty;
function zf(t) {
  var e = this.__data__;
  return Uf ? e[t] !== void 0 : Gf.call(e, t);
}
var Hf = zf, qf = Ot, Yf = "__lodash_hash_undefined__";
function Kf(t, e) {
  var r = this.__data__;
  return this.size += this.has(t) ? 0 : 1, r[t] = qf && e === void 0 ? Yf : e, this;
}
var Wf = Kf, Vf = Pf, Zf = If, Jf = kf, Xf = Hf, Qf = Wf;
function W(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
W.prototype.clear = Vf;
W.prototype.delete = Zf;
W.prototype.get = Jf;
W.prototype.has = Xf;
W.prototype.set = Qf;
var tp = W, vr = tp, ep = wt, rp = je;
function np() {
  this.size = 0, this.__data__ = {
    hash: new vr(),
    map: new (rp || ep)(),
    string: new vr()
  };
}
var ip = np;
function ap(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var sp = ap, op = sp;
function up(t, e) {
  var r = t.__data__;
  return op(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
var Tt = up, cp = Tt;
function fp(t) {
  var e = cp(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var pp = fp, hp = Tt;
function lp(t) {
  return hp(this, t).get(t);
}
var dp = lp, _p = Tt;
function vp(t) {
  return _p(this, t).has(t);
}
var gp = vp, yp = Tt;
function bp(t, e) {
  var r = yp(this, t), n = r.size;
  return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
}
var mp = bp, Sp = ip, xp = pp, Ep = dp, $p = gp, Ap = mp;
function V(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
V.prototype.clear = Sp;
V.prototype.delete = xp;
V.prototype.get = Ep;
V.prototype.has = $p;
V.prototype.set = Ap;
var Pe = V, wp = wt, Op = je, Tp = Pe, Cp = 200;
function jp(t, e) {
  var r = this.__data__;
  if (r instanceof wp) {
    var n = r.__data__;
    if (!Op || n.length < Cp - 1)
      return n.push([t, e]), this.size = ++r.size, this;
    r = this.__data__ = new Tp(n);
  }
  return r.set(t, e), this.size = r.size, this;
}
var Pp = jp, Rp = wt, Ip = yf, Dp = mf, Lp = xf, Fp = $f, Np = Pp;
function Z(t) {
  var e = this.__data__ = new Rp(t);
  this.size = e.size;
}
Z.prototype.clear = Ip;
Z.prototype.delete = Dp;
Z.prototype.get = Lp;
Z.prototype.has = Fp;
Z.prototype.set = Np;
var ni = Z, Mp = "__lodash_hash_undefined__";
function kp(t) {
  return this.__data__.set(t, Mp), this;
}
var Up = kp;
function Bp(t) {
  return this.__data__.has(t);
}
var Gp = Bp, zp = Pe, Hp = Up, qp = Gp;
function bt(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.__data__ = new zp(); ++e < r; )
    this.add(t[e]);
}
bt.prototype.add = bt.prototype.push = Hp;
bt.prototype.has = qp;
var Yp = bt;
function Kp(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n; )
    if (e(t[r], r, t))
      return !0;
  return !1;
}
var Wp = Kp;
function Vp(t, e) {
  return t.has(e);
}
var Zp = Vp, Jp = Yp, Xp = Wp, Qp = Zp, th = 1, eh = 2;
function rh(t, e, r, n, i, a) {
  var s = r & th, o = t.length, f = e.length;
  if (o != f && !(s && f > o))
    return !1;
  var p = a.get(t), d = a.get(e);
  if (p && d)
    return p == e && d == t;
  var _ = -1, g = !0, S = r & eh ? new Jp() : void 0;
  for (a.set(t, e), a.set(e, t); ++_ < o; ) {
    var x = t[_], E = e[_];
    if (n)
      var O = s ? n(E, x, _, e, t, a) : n(x, E, _, t, e, a);
    if (O !== void 0) {
      if (O)
        continue;
      g = !1;
      break;
    }
    if (S) {
      if (!Xp(e, function(T, u) {
        if (!Qp(S, u) && (x === T || i(x, T, r, n, a)))
          return S.push(u);
      })) {
        g = !1;
        break;
      }
    } else if (!(x === E || i(x, E, r, n, a))) {
      g = !1;
      break;
    }
  }
  return a.delete(t), a.delete(e), g;
}
var ii = rh, nh = j, ih = nh.Uint8Array, ah = ih;
function sh(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n, i) {
    r[++e] = [i, n];
  }), r;
}
var oh = sh;
function uh(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n) {
    r[++e] = n;
  }), r;
}
var ch = uh, gr = $t, yr = ah, fh = ri, ph = ii, hh = oh, lh = ch, dh = 1, _h = 2, vh = "[object Boolean]", gh = "[object Date]", yh = "[object Error]", bh = "[object Map]", mh = "[object Number]", Sh = "[object RegExp]", xh = "[object Set]", Eh = "[object String]", $h = "[object Symbol]", Ah = "[object ArrayBuffer]", wh = "[object DataView]", br = gr ? gr.prototype : void 0, Ut = br ? br.valueOf : void 0;
function Oh(t, e, r, n, i, a, s) {
  switch (r) {
    case wh:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case Ah:
      return !(t.byteLength != e.byteLength || !a(new yr(t), new yr(e)));
    case vh:
    case gh:
    case mh:
      return fh(+t, +e);
    case yh:
      return t.name == e.name && t.message == e.message;
    case Sh:
    case Eh:
      return t == e + "";
    case bh:
      var o = hh;
    case xh:
      var f = n & dh;
      if (o || (o = lh), t.size != e.size && !f)
        return !1;
      var p = s.get(t);
      if (p)
        return p == e;
      n |= _h, s.set(t, e);
      var d = ph(o(t), o(e), n, i, a, s);
      return s.delete(t), d;
    case $h:
      if (Ut)
        return Ut.call(t) == Ut.call(e);
  }
  return !1;
}
var Th = Oh;
function Ch(t, e) {
  for (var r = -1, n = e.length, i = t.length; ++r < n; )
    t[i + r] = e[r];
  return t;
}
var jh = Ch, Ph = jh, Rh = N;
function Ih(t, e, r) {
  var n = e(t);
  return Rh(t) ? n : Ph(n, r(t));
}
var Dh = Ih;
function Lh(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, i = 0, a = []; ++r < n; ) {
    var s = t[r];
    e(s, r, t) && (a[i++] = s);
  }
  return a;
}
var Fh = Lh;
function Nh() {
  return [];
}
var Mh = Nh, kh = Fh, Uh = Mh, Bh = Object.prototype, Gh = Bh.propertyIsEnumerable, mr = Object.getOwnPropertySymbols, zh = mr ? function(t) {
  return t == null ? [] : (t = Object(t), kh(mr(t), function(e) {
    return Gh.call(t, e);
  }));
} : Uh, Hh = zh, qh = Dh, Yh = Hh, Kh = Ce;
function Wh(t) {
  return qh(t, Kh, Yh);
}
var Vh = Wh, Sr = Vh, Zh = 1, Jh = Object.prototype, Xh = Jh.hasOwnProperty;
function Qh(t, e, r, n, i, a) {
  var s = r & Zh, o = Sr(t), f = o.length, p = Sr(e), d = p.length;
  if (f != d && !s)
    return !1;
  for (var _ = f; _--; ) {
    var g = o[_];
    if (!(s ? g in e : Xh.call(e, g)))
      return !1;
  }
  var S = a.get(t), x = a.get(e);
  if (S && x)
    return S == e && x == t;
  var E = !0;
  a.set(t, e), a.set(e, t);
  for (var O = s; ++_ < f; ) {
    g = o[_];
    var T = t[g], u = e[g];
    if (n)
      var c = s ? n(u, T, g, e, t, a) : n(T, u, g, t, e, a);
    if (!(c === void 0 ? T === u || i(T, u, r, n, a) : c)) {
      E = !1;
      break;
    }
    O || (O = g == "constructor");
  }
  if (E && !O) {
    var l = t.constructor, h = e.constructor;
    l != h && "constructor" in t && "constructor" in e && !(typeof l == "function" && l instanceof l && typeof h == "function" && h instanceof h) && (E = !1);
  }
  return a.delete(t), a.delete(e), E;
}
var tl = Qh, el = z, rl = j, nl = el(rl, "DataView"), il = nl, al = z, sl = j, ol = al(sl, "Promise"), ul = ol, cl = z, fl = j, pl = cl(fl, "Set"), hl = pl, ll = z, dl = j, _l = ll(dl, "WeakMap"), vl = _l, re = il, ne = je, ie = ul, ae = hl, se = vl, ai = ct, J = Jn, xr = "[object Map]", gl = "[object Object]", Er = "[object Promise]", $r = "[object Set]", Ar = "[object WeakMap]", wr = "[object DataView]", yl = J(re), bl = J(ne), ml = J(ie), Sl = J(ae), xl = J(se), U = ai;
(re && U(new re(new ArrayBuffer(1))) != wr || ne && U(new ne()) != xr || ie && U(ie.resolve()) != Er || ae && U(new ae()) != $r || se && U(new se()) != Ar) && (U = function(t) {
  var e = ai(t), r = e == gl ? t.constructor : void 0, n = r ? J(r) : "";
  if (n)
    switch (n) {
      case yl:
        return wr;
      case bl:
        return xr;
      case ml:
        return Er;
      case Sl:
        return $r;
      case xl:
        return Ar;
    }
  return e;
});
var El = U, Bt = ni, $l = ii, Al = Th, wl = tl, Or = El, Tr = N, Cr = yt.exports, Ol = ei, Tl = 1, jr = "[object Arguments]", Pr = "[object Array]", dt = "[object Object]", Cl = Object.prototype, Rr = Cl.hasOwnProperty;
function jl(t, e, r, n, i, a) {
  var s = Tr(t), o = Tr(e), f = s ? Pr : Or(t), p = o ? Pr : Or(e);
  f = f == jr ? dt : f, p = p == jr ? dt : p;
  var d = f == dt, _ = p == dt, g = f == p;
  if (g && Cr(t)) {
    if (!Cr(e))
      return !1;
    s = !0, d = !1;
  }
  if (g && !d)
    return a || (a = new Bt()), s || Ol(t) ? $l(t, e, r, n, i, a) : Al(t, e, f, r, n, i, a);
  if (!(r & Tl)) {
    var S = d && Rr.call(t, "__wrapped__"), x = _ && Rr.call(e, "__wrapped__");
    if (S || x) {
      var E = S ? t.value() : t, O = x ? e.value() : e;
      return a || (a = new Bt()), i(E, O, r, n, a);
    }
  }
  return g ? (a || (a = new Bt()), wl(t, e, r, n, i, a)) : !1;
}
var Pl = jl, Rl = Pl, Ir = ft;
function si(t, e, r, n, i) {
  return t === e ? !0 : t == null || e == null || !Ir(t) && !Ir(e) ? t !== t && e !== e : Rl(t, e, r, n, si, i);
}
var oi = si, Il = ni, Dl = oi, Ll = 1, Fl = 2;
function Nl(t, e, r, n) {
  var i = r.length, a = i, s = !n;
  if (t == null)
    return !a;
  for (t = Object(t); i--; ) {
    var o = r[i];
    if (s && o[2] ? o[1] !== t[o[0]] : !(o[0] in t))
      return !1;
  }
  for (; ++i < a; ) {
    o = r[i];
    var f = o[0], p = t[f], d = o[1];
    if (s && o[2]) {
      if (p === void 0 && !(f in t))
        return !1;
    } else {
      var _ = new Il();
      if (n)
        var g = n(p, d, f, t, e, _);
      if (!(g === void 0 ? Dl(d, p, Ll | Fl, n, _) : g))
        return !1;
    }
  }
  return !0;
}
var Ml = Nl, kl = Oe;
function Ul(t) {
  return t === t && !kl(t);
}
var ui = Ul, Bl = ui, Gl = Ce;
function zl(t) {
  for (var e = Gl(t), r = e.length; r--; ) {
    var n = e[r], i = t[n];
    e[r] = [n, i, Bl(i)];
  }
  return e;
}
var Hl = zl;
function ql(t, e) {
  return function(r) {
    return r == null ? !1 : r[t] === e && (e !== void 0 || t in Object(r));
  };
}
var ci = ql, Yl = Ml, Kl = Hl, Wl = ci;
function Vl(t) {
  var e = Kl(t);
  return e.length == 1 && e[0][2] ? Wl(e[0][0], e[0][1]) : function(r) {
    return r === t || Yl(r, t, e);
  };
}
var Zl = Vl, Jl = N, Xl = Ae, Ql = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, td = /^\w*$/;
function ed(t, e) {
  if (Jl(t))
    return !1;
  var r = typeof t;
  return r == "number" || r == "symbol" || r == "boolean" || t == null || Xl(t) ? !0 : td.test(t) || !Ql.test(t) || e != null && t in Object(e);
}
var Re = ed, fi = Pe, rd = "Expected a function";
function Ie(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(rd);
  var r = function() {
    var n = arguments, i = e ? e.apply(this, n) : n[0], a = r.cache;
    if (a.has(i))
      return a.get(i);
    var s = t.apply(this, n);
    return r.cache = a.set(i, s) || a, s;
  };
  return r.cache = new (Ie.Cache || fi)(), r;
}
Ie.Cache = fi;
var nd = Ie, id = nd, ad = 500;
function sd(t) {
  var e = id(t, function(n) {
    return r.size === ad && r.clear(), n;
  }), r = e.cache;
  return e;
}
var od = sd, ud = od, cd = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, fd = /\\(\\)?/g, pd = ud(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(cd, function(r, n, i, a) {
    e.push(i ? a.replace(fd, "$1") : n || r);
  }), e;
}), hd = pd, ld = N, dd = Re, _d = hd, vd = we;
function gd(t, e) {
  return ld(t) ? t : dd(t, e) ? [t] : _d(vd(t));
}
var pi = gd, yd = Ae, bd = 1 / 0;
function md(t) {
  if (typeof t == "string" || yd(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -bd ? "-0" : e;
}
var Ct = md, Sd = pi, xd = Ct;
function Ed(t, e) {
  e = Sd(e, t);
  for (var r = 0, n = e.length; t != null && r < n; )
    t = t[xd(e[r++])];
  return r && r == n ? t : void 0;
}
var hi = Ed, $d = hi;
function Ad(t, e, r) {
  var n = t == null ? void 0 : $d(t, e);
  return n === void 0 ? r : n;
}
var wd = Ad;
function Od(t, e) {
  return t != null && e in Object(t);
}
var Td = Od, Cd = pi, jd = Qn, Pd = N, Rd = ti, Id = Te, Dd = Ct;
function Ld(t, e, r) {
  e = Cd(e, t);
  for (var n = -1, i = e.length, a = !1; ++n < i; ) {
    var s = Dd(e[n]);
    if (!(a = t != null && r(t, s)))
      break;
    t = t[s];
  }
  return a || ++n != i ? a : (i = t == null ? 0 : t.length, !!i && Id(i) && Rd(s, i) && (Pd(t) || jd(t)));
}
var Fd = Ld, Nd = Td, Md = Fd;
function kd(t, e) {
  return t != null && Md(t, e, Nd);
}
var Ud = kd, Bd = oi, Gd = wd, zd = Ud, Hd = Re, qd = ui, Yd = ci, Kd = Ct, Wd = 1, Vd = 2;
function Zd(t, e) {
  return Hd(t) && qd(e) ? Yd(Kd(t), e) : function(r) {
    var n = Gd(r, t);
    return n === void 0 && n === e ? zd(r, t) : Bd(e, n, Wd | Vd);
  };
}
var Jd = Zd;
function Xd(t) {
  return t;
}
var Qd = Xd;
function t_(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
var e_ = t_, r_ = hi;
function n_(t) {
  return function(e) {
    return r_(e, t);
  };
}
var i_ = n_, a_ = e_, s_ = i_, o_ = Re, u_ = Ct;
function c_(t) {
  return o_(t) ? a_(u_(t)) : s_(t);
}
var f_ = c_, p_ = Zl, h_ = Jd, l_ = Qd, d_ = N, __ = f_;
function v_(t) {
  return typeof t == "function" ? t : t == null ? l_ : typeof t == "object" ? d_(t) ? h_(t[0], t[1]) : p_(t) : __(t);
}
var g_ = v_, y_ = au, b_ = Hc, m_ = g_;
function S_(t, e) {
  var r = {};
  return e = m_(e), b_(t, function(n, i, a) {
    y_(r, e(n, i, a), n);
  }), r;
}
var Gt = S_, oe = {}, x_ = (t) => encodeURIComponent(t).replace(/[!'()*]/g, (e) => `%${e.charCodeAt(0).toString(16).toUpperCase()}`), li = "%[a-f0-9]{2}", Dr = new RegExp("(" + li + ")|([^%]+?)", "gi"), Lr = new RegExp("(" + li + ")+", "gi");
function ue(t, e) {
  try {
    return [decodeURIComponent(t.join(""))];
  } catch {
  }
  if (t.length === 1)
    return t;
  e = e || 1;
  var r = t.slice(0, e), n = t.slice(e);
  return Array.prototype.concat.call([], ue(r), ue(n));
}
function E_(t) {
  try {
    return decodeURIComponent(t);
  } catch {
    for (var e = t.match(Dr) || [], r = 1; r < e.length; r++)
      t = ue(e, r).join(""), e = t.match(Dr) || [];
    return t;
  }
}
function $_(t) {
  for (var e = {
    "%FE%FF": "\uFFFD\uFFFD",
    "%FF%FE": "\uFFFD\uFFFD"
  }, r = Lr.exec(t); r; ) {
    try {
      e[r[0]] = decodeURIComponent(r[0]);
    } catch {
      var n = E_(r[0]);
      n !== r[0] && (e[r[0]] = n);
    }
    r = Lr.exec(t);
  }
  e["%C2"] = "\uFFFD";
  for (var i = Object.keys(e), a = 0; a < i.length; a++) {
    var s = i[a];
    t = t.replace(new RegExp(s, "g"), e[s]);
  }
  return t;
}
var A_ = function(t) {
  if (typeof t != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof t + "`");
  try {
    return t = t.replace(/\+/g, " "), decodeURIComponent(t);
  } catch {
    return $_(t);
  }
}, w_ = (t, e) => {
  if (!(typeof t == "string" && typeof e == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (e === "")
    return [t];
  const r = t.indexOf(e);
  return r === -1 ? [t] : [
    t.slice(0, r),
    t.slice(r + e.length)
  ];
}, O_ = function(t, e) {
  for (var r = {}, n = Object.keys(t), i = Array.isArray(e), a = 0; a < n.length; a++) {
    var s = n[a], o = t[s];
    (i ? e.indexOf(s) !== -1 : e(s, o, t)) && (r[s] = o);
  }
  return r;
};
(function(t) {
  const e = x_, r = A_, n = w_, i = O_, a = (u) => u == null, s = Symbol("encodeFragmentIdentifier");
  function o(u) {
    switch (u.arrayFormat) {
      case "index":
        return (c) => (l, h) => {
          const v = l.length;
          return h === void 0 || u.skipNull && h === null || u.skipEmptyString && h === "" ? l : h === null ? [...l, [d(c, u), "[", v, "]"].join("")] : [
            ...l,
            [d(c, u), "[", d(v, u), "]=", d(h, u)].join("")
          ];
        };
      case "bracket":
        return (c) => (l, h) => h === void 0 || u.skipNull && h === null || u.skipEmptyString && h === "" ? l : h === null ? [...l, [d(c, u), "[]"].join("")] : [...l, [d(c, u), "[]=", d(h, u)].join("")];
      case "colon-list-separator":
        return (c) => (l, h) => h === void 0 || u.skipNull && h === null || u.skipEmptyString && h === "" ? l : h === null ? [...l, [d(c, u), ":list="].join("")] : [...l, [d(c, u), ":list=", d(h, u)].join("")];
      case "comma":
      case "separator":
      case "bracket-separator": {
        const c = u.arrayFormat === "bracket-separator" ? "[]=" : "=";
        return (l) => (h, v) => v === void 0 || u.skipNull && v === null || u.skipEmptyString && v === "" ? h : (v = v === null ? "" : v, h.length === 0 ? [[d(l, u), c, d(v, u)].join("")] : [[h, d(v, u)].join(u.arrayFormatSeparator)]);
      }
      default:
        return (c) => (l, h) => h === void 0 || u.skipNull && h === null || u.skipEmptyString && h === "" ? l : h === null ? [...l, d(c, u)] : [...l, [d(c, u), "=", d(h, u)].join("")];
    }
  }
  function f(u) {
    let c;
    switch (u.arrayFormat) {
      case "index":
        return (l, h, v) => {
          if (c = /\[(\d*)\]$/.exec(l), l = l.replace(/\[\d*\]$/, ""), !c) {
            v[l] = h;
            return;
          }
          v[l] === void 0 && (v[l] = {}), v[l][c[1]] = h;
        };
      case "bracket":
        return (l, h, v) => {
          if (c = /(\[\])$/.exec(l), l = l.replace(/\[\]$/, ""), !c) {
            v[l] = h;
            return;
          }
          if (v[l] === void 0) {
            v[l] = [h];
            return;
          }
          v[l] = [].concat(v[l], h);
        };
      case "colon-list-separator":
        return (l, h, v) => {
          if (c = /(:list)$/.exec(l), l = l.replace(/:list$/, ""), !c) {
            v[l] = h;
            return;
          }
          if (v[l] === void 0) {
            v[l] = [h];
            return;
          }
          v[l] = [].concat(v[l], h);
        };
      case "comma":
      case "separator":
        return (l, h, v) => {
          const $ = typeof h == "string" && h.includes(u.arrayFormatSeparator), m = typeof h == "string" && !$ && _(h, u).includes(u.arrayFormatSeparator);
          h = m ? _(h, u) : h;
          const C = $ || m ? h.split(u.arrayFormatSeparator).map((ra) => _(ra, u)) : h === null ? h : _(h, u);
          v[l] = C;
        };
      case "bracket-separator":
        return (l, h, v) => {
          const $ = /(\[\])$/.test(l);
          if (l = l.replace(/\[\]$/, ""), !$) {
            v[l] = h && _(h, u);
            return;
          }
          const m = h === null ? [] : h.split(u.arrayFormatSeparator).map((C) => _(C, u));
          if (v[l] === void 0) {
            v[l] = m;
            return;
          }
          v[l] = [].concat(v[l], m);
        };
      default:
        return (l, h, v) => {
          if (v[l] === void 0) {
            v[l] = h;
            return;
          }
          v[l] = [].concat(v[l], h);
        };
    }
  }
  function p(u) {
    if (typeof u != "string" || u.length !== 1)
      throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function d(u, c) {
    return c.encode ? c.strict ? e(u) : encodeURIComponent(u) : u;
  }
  function _(u, c) {
    return c.decode ? r(u) : u;
  }
  function g(u) {
    return Array.isArray(u) ? u.sort() : typeof u == "object" ? g(Object.keys(u)).sort((c, l) => Number(c) - Number(l)).map((c) => u[c]) : u;
  }
  function S(u) {
    const c = u.indexOf("#");
    return c !== -1 && (u = u.slice(0, c)), u;
  }
  function x(u) {
    let c = "";
    const l = u.indexOf("#");
    return l !== -1 && (c = u.slice(l)), c;
  }
  function E(u) {
    u = S(u);
    const c = u.indexOf("?");
    return c === -1 ? "" : u.slice(c + 1);
  }
  function O(u, c) {
    return c.parseNumbers && !Number.isNaN(Number(u)) && typeof u == "string" && u.trim() !== "" ? u = Number(u) : c.parseBooleans && u !== null && (u.toLowerCase() === "true" || u.toLowerCase() === "false") && (u = u.toLowerCase() === "true"), u;
  }
  function T(u, c) {
    c = Object.assign({
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      parseNumbers: !1,
      parseBooleans: !1
    }, c), p(c.arrayFormatSeparator);
    const l = f(c), h = /* @__PURE__ */ Object.create(null);
    if (typeof u != "string" || (u = u.trim().replace(/^[?#&]/, ""), !u))
      return h;
    for (const v of u.split("&")) {
      if (v === "")
        continue;
      let [$, m] = n(c.decode ? v.replace(/\+/g, " ") : v, "=");
      m = m === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(c.arrayFormat) ? m : _(m, c), l(_($, c), m, h);
    }
    for (const v of Object.keys(h)) {
      const $ = h[v];
      if (typeof $ == "object" && $ !== null)
        for (const m of Object.keys($))
          $[m] = O($[m], c);
      else
        h[v] = O($, c);
    }
    return c.sort === !1 ? h : (c.sort === !0 ? Object.keys(h).sort() : Object.keys(h).sort(c.sort)).reduce((v, $) => {
      const m = h[$];
      return Boolean(m) && typeof m == "object" && !Array.isArray(m) ? v[$] = g(m) : v[$] = m, v;
    }, /* @__PURE__ */ Object.create(null));
  }
  t.extract = E, t.parse = T, t.stringify = (u, c) => {
    if (!u)
      return "";
    c = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ","
    }, c), p(c.arrayFormatSeparator);
    const l = (m) => c.skipNull && a(u[m]) || c.skipEmptyString && u[m] === "", h = o(c), v = {};
    for (const m of Object.keys(u))
      l(m) || (v[m] = u[m]);
    const $ = Object.keys(v);
    return c.sort !== !1 && $.sort(c.sort), $.map((m) => {
      const C = u[m];
      return C === void 0 ? "" : C === null ? d(m, c) : Array.isArray(C) ? C.length === 0 && c.arrayFormat === "bracket-separator" ? d(m, c) + "[]" : C.reduce(h(m), []).join("&") : d(m, c) + "=" + d(C, c);
    }).filter((m) => m.length > 0).join("&");
  }, t.parseUrl = (u, c) => {
    c = Object.assign({
      decode: !0
    }, c);
    const [l, h] = n(u, "#");
    return Object.assign(
      {
        url: l.split("?")[0] || "",
        query: T(E(u), c)
      },
      c && c.parseFragmentIdentifier && h ? { fragmentIdentifier: _(h, c) } : {}
    );
  }, t.stringifyUrl = (u, c) => {
    c = Object.assign({
      encode: !0,
      strict: !0,
      [s]: !0
    }, c);
    const l = S(u.url).split("?")[0] || "", h = t.extract(u.url), v = t.parse(h, { sort: !1 }), $ = Object.assign(v, u.query);
    let m = t.stringify($, c);
    m && (m = `?${m}`);
    let C = x(u.url);
    return u.fragmentIdentifier && (C = `#${c[s] ? d(u.fragmentIdentifier, c) : u.fragmentIdentifier}`), `${l}${m}${C}`;
  }, t.pick = (u, c, l) => {
    l = Object.assign({
      parseFragmentIdentifier: !0,
      [s]: !1
    }, l);
    const { url: h, query: v, fragmentIdentifier: $ } = t.parseUrl(u, l);
    return t.stringifyUrl({
      url: h,
      query: i(v, c),
      fragmentIdentifier: $
    }, l);
  }, t.exclude = (u, c, l) => {
    const h = Array.isArray(c) ? (v) => !c.includes(v) : (v, $) => !c(v, $);
    return t.pick(u, h, l);
  };
})(oe);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var b = function() {
  return b = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, b.apply(this, arguments);
};
function T_(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], n = 0;
  if (r)
    return r.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && n >= t.length && (t = void 0), { value: t && t[n++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function C_(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r)
    return t;
  var n = r.call(t), i, a = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; )
      a.push(i.value);
  } catch (o) {
    s = { error: o };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return a;
}
function D() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t = t.concat(C_(arguments[e]));
  return t;
}
function j_() {
  return typeof __SENTRY_BROWSER_BUNDLE__ < "u" && !!__SENTRY_BROWSER_BUNDLE__;
}
function De() {
  return !j_() && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]";
}
function P_(t, e) {
  return t.require(e);
}
var R_ = {};
function M() {
  return De() ? global : typeof window < "u" ? window : typeof self < "u" ? self : R_;
}
function Le(t, e, r) {
  var n = r || M(), i = n.__SENTRY__ = n.__SENTRY__ || {}, a = i[t] || (i[t] = e());
  return a;
}
var I_ = Object.prototype.toString;
function D_(t, e) {
  return I_.call(t) === "[object " + e + "]";
}
function di(t) {
  return D_(t, "Object");
}
function _i(t) {
  return Boolean(t && t.then && typeof t.then == "function");
}
var vi = typeof __SENTRY_DEBUG__ > "u" ? !0 : __SENTRY_DEBUG__, L_ = M(), F_ = "Sentry Logger ", ce = ["debug", "info", "warn", "error", "log", "assert"];
function gi(t) {
  var e = M();
  if (!("console" in e))
    return t();
  var r = e.console, n = {};
  ce.forEach(function(i) {
    var a = r[i] && r[i].__sentry_original__;
    i in e.console && a && (n[i] = r[i], r[i] = a);
  });
  try {
    return t();
  } finally {
    Object.keys(n).forEach(function(i) {
      r[i] = n[i];
    });
  }
}
function Fr() {
  var t = !1, e = {
    enable: function() {
      t = !0;
    },
    disable: function() {
      t = !1;
    }
  };
  return vi ? ce.forEach(function(r) {
    e[r] = function() {
      for (var n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      t && gi(function() {
        var a;
        (a = L_.console)[r].apply(a, D([F_ + "[" + r + "]:"], n));
      });
    };
  }) : ce.forEach(function(r) {
    e[r] = function() {
    };
  }), e;
}
var mt;
vi ? mt = Le("logger", Fr) : mt = Fr();
function fe(t) {
  var e, r;
  if (di(t)) {
    var n = {};
    try {
      for (var i = T_(Object.keys(t)), a = i.next(); !a.done; a = i.next()) {
        var s = a.value;
        typeof t[s] < "u" && (n[s] = fe(t[s]));
      }
    } catch (o) {
      e = { error: o };
    } finally {
      try {
        a && !a.done && (r = i.return) && r.call(i);
      } finally {
        if (e)
          throw e.error;
      }
    }
    return n;
  }
  return Array.isArray(t) ? t.map(fe) : t;
}
function ot() {
  var t = M(), e = t.crypto || t.msCrypto;
  if (e !== void 0 && e.getRandomValues) {
    var r = new Uint16Array(8);
    e.getRandomValues(r), r[3] = r[3] & 4095 | 16384, r[4] = r[4] & 16383 | 32768;
    var n = function(i) {
      for (var a = i.toString(16); a.length < 4; )
        a = "0" + a;
      return a;
    };
    return n(r[0]) + n(r[1]) + n(r[2]) + n(r[3]) + n(r[4]) + n(r[5]) + n(r[6]) + n(r[7]);
  }
  return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(i) {
    var a = Math.random() * 16 | 0, s = i === "x" ? a : a & 3 | 8;
    return s.toString(16);
  });
}
var N_ = function() {
  function t(e) {
    var r = this;
    this._state = 0, this._handlers = [], this._resolve = function(n) {
      r._setResult(1, n);
    }, this._reject = function(n) {
      r._setResult(2, n);
    }, this._setResult = function(n, i) {
      if (r._state === 0) {
        if (_i(i)) {
          i.then(r._resolve, r._reject);
          return;
        }
        r._state = n, r._value = i, r._executeHandlers();
      }
    }, this._executeHandlers = function() {
      if (r._state !== 0) {
        var n = r._handlers.slice();
        r._handlers = [], n.forEach(function(i) {
          i[0] || (r._state === 1 && i[1](r._value), r._state === 2 && i[2](r._value), i[0] = !0);
        });
      }
    };
    try {
      e(this._resolve, this._reject);
    } catch (n) {
      this._reject(n);
    }
  }
  return t.prototype.then = function(e, r) {
    var n = this;
    return new t(function(i, a) {
      n._handlers.push([
        !1,
        function(s) {
          if (!e)
            i(s);
          else
            try {
              i(e(s));
            } catch (o) {
              a(o);
            }
        },
        function(s) {
          if (!r)
            a(s);
          else
            try {
              i(r(s));
            } catch (o) {
              a(o);
            }
        }
      ]), n._executeHandlers();
    });
  }, t.prototype.catch = function(e) {
    return this.then(function(r) {
      return r;
    }, e);
  }, t.prototype.finally = function(e) {
    var r = this;
    return new t(function(n, i) {
      var a, s;
      return r.then(function(o) {
        s = !1, a = o, e && e();
      }, function(o) {
        s = !0, a = o, e && e();
      }).then(function() {
        if (s) {
          i(a);
          return;
        }
        n(a);
      });
    });
  }, t;
}(), pe = {
  nowSeconds: function() {
    return Date.now() / 1e3;
  }
};
function M_() {
  var t = M().performance;
  if (!(!t || !t.now)) {
    var e = Date.now() - t.now();
    return {
      now: function() {
        return t.now();
      },
      timeOrigin: e
    };
  }
}
function k_() {
  try {
    var t = P_(module, "perf_hooks");
    return t.performance;
  } catch {
    return;
  }
}
var zt = De() ? k_() : M_(), Nr = zt === void 0 ? pe : {
  nowSeconds: function() {
    return (zt.timeOrigin + zt.now()) / 1e3;
  }
}, yi = pe.nowSeconds.bind(pe), Mr = Nr.nowSeconds.bind(Nr);
(function() {
  var t = M().performance;
  if (!(!t || !t.now)) {
    var e = 36e5, r = t.now(), n = Date.now(), i = t.timeOrigin ? Math.abs(t.timeOrigin + r - n) : e, a = i < e, s = t.timing && t.timing.navigationStart, o = typeof s == "number", f = o ? Math.abs(s + r - n) : e, p = f < e;
    return a || p ? i <= f ? t.timeOrigin : s : n;
  }
})();
var kr = 100, he = function() {
  function t() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {};
  }
  return t.clone = function(e) {
    var r = new t();
    return e && (r._breadcrumbs = D(e._breadcrumbs), r._tags = b({}, e._tags), r._extra = b({}, e._extra), r._contexts = b({}, e._contexts), r._user = e._user, r._level = e._level, r._span = e._span, r._session = e._session, r._transactionName = e._transactionName, r._fingerprint = e._fingerprint, r._eventProcessors = D(e._eventProcessors), r._requestSession = e._requestSession), r;
  }, t.prototype.addScopeListener = function(e) {
    this._scopeListeners.push(e);
  }, t.prototype.addEventProcessor = function(e) {
    return this._eventProcessors.push(e), this;
  }, t.prototype.setUser = function(e) {
    return this._user = e || {}, this._session && this._session.update({ user: e }), this._notifyScopeListeners(), this;
  }, t.prototype.getUser = function() {
    return this._user;
  }, t.prototype.getRequestSession = function() {
    return this._requestSession;
  }, t.prototype.setRequestSession = function(e) {
    return this._requestSession = e, this;
  }, t.prototype.setTags = function(e) {
    return this._tags = b(b({}, this._tags), e), this._notifyScopeListeners(), this;
  }, t.prototype.setTag = function(e, r) {
    var n;
    return this._tags = b(b({}, this._tags), (n = {}, n[e] = r, n)), this._notifyScopeListeners(), this;
  }, t.prototype.setExtras = function(e) {
    return this._extra = b(b({}, this._extra), e), this._notifyScopeListeners(), this;
  }, t.prototype.setExtra = function(e, r) {
    var n;
    return this._extra = b(b({}, this._extra), (n = {}, n[e] = r, n)), this._notifyScopeListeners(), this;
  }, t.prototype.setFingerprint = function(e) {
    return this._fingerprint = e, this._notifyScopeListeners(), this;
  }, t.prototype.setLevel = function(e) {
    return this._level = e, this._notifyScopeListeners(), this;
  }, t.prototype.setTransactionName = function(e) {
    return this._transactionName = e, this._notifyScopeListeners(), this;
  }, t.prototype.setTransaction = function(e) {
    return this.setTransactionName(e);
  }, t.prototype.setContext = function(e, r) {
    var n;
    return r === null ? delete this._contexts[e] : this._contexts = b(b({}, this._contexts), (n = {}, n[e] = r, n)), this._notifyScopeListeners(), this;
  }, t.prototype.setSpan = function(e) {
    return this._span = e, this._notifyScopeListeners(), this;
  }, t.prototype.getSpan = function() {
    return this._span;
  }, t.prototype.getTransaction = function() {
    var e = this.getSpan();
    return e && e.transaction;
  }, t.prototype.setSession = function(e) {
    return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
  }, t.prototype.getSession = function() {
    return this._session;
  }, t.prototype.update = function(e) {
    if (!e)
      return this;
    if (typeof e == "function") {
      var r = e(this);
      return r instanceof t ? r : this;
    }
    return e instanceof t ? (this._tags = b(b({}, this._tags), e._tags), this._extra = b(b({}, this._extra), e._extra), this._contexts = b(b({}, this._contexts), e._contexts), e._user && Object.keys(e._user).length && (this._user = e._user), e._level && (this._level = e._level), e._fingerprint && (this._fingerprint = e._fingerprint), e._requestSession && (this._requestSession = e._requestSession)) : di(e) && (e = e, this._tags = b(b({}, this._tags), e.tags), this._extra = b(b({}, this._extra), e.extra), this._contexts = b(b({}, this._contexts), e.contexts), e.user && (this._user = e.user), e.level && (this._level = e.level), e.fingerprint && (this._fingerprint = e.fingerprint), e.requestSession && (this._requestSession = e.requestSession)), this;
  }, t.prototype.clear = function() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._span = void 0, this._session = void 0, this._notifyScopeListeners(), this;
  }, t.prototype.addBreadcrumb = function(e, r) {
    var n = typeof r == "number" ? Math.min(r, kr) : kr;
    if (n <= 0)
      return this;
    var i = b({ timestamp: yi() }, e);
    return this._breadcrumbs = D(this._breadcrumbs, [i]).slice(-n), this._notifyScopeListeners(), this;
  }, t.prototype.clearBreadcrumbs = function() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }, t.prototype.applyToEvent = function(e, r) {
    if (this._extra && Object.keys(this._extra).length && (e.extra = b(b({}, this._extra), e.extra)), this._tags && Object.keys(this._tags).length && (e.tags = b(b({}, this._tags), e.tags)), this._user && Object.keys(this._user).length && (e.user = b(b({}, this._user), e.user)), this._contexts && Object.keys(this._contexts).length && (e.contexts = b(b({}, this._contexts), e.contexts)), this._level && (e.level = this._level), this._transactionName && (e.transaction = this._transactionName), this._span) {
      e.contexts = b({ trace: this._span.getTraceContext() }, e.contexts);
      var n = this._span.transaction && this._span.transaction.name;
      n && (e.tags = b({ transaction: n }, e.tags));
    }
    return this._applyFingerprint(e), e.breadcrumbs = D(e.breadcrumbs || [], this._breadcrumbs), e.breadcrumbs = e.breadcrumbs.length > 0 ? e.breadcrumbs : void 0, e.sdkProcessingMetadata = this._sdkProcessingMetadata, this._notifyEventProcessors(D(U_(), this._eventProcessors), e, r);
  }, t.prototype.setSDKProcessingMetadata = function(e) {
    return this._sdkProcessingMetadata = b(b({}, this._sdkProcessingMetadata), e), this;
  }, t.prototype._notifyEventProcessors = function(e, r, n, i) {
    var a = this;
    return i === void 0 && (i = 0), new N_(function(s, o) {
      var f = e[i];
      if (r === null || typeof f != "function")
        s(r);
      else {
        var p = f(b({}, r), n);
        _i(p) ? p.then(function(d) {
          return a._notifyEventProcessors(e, d, n, i + 1).then(s);
        }).then(null, o) : a._notifyEventProcessors(e, p, n, i + 1).then(s).then(null, o);
      }
    });
  }, t.prototype._notifyScopeListeners = function() {
    var e = this;
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach(function(r) {
      r(e);
    }), this._notifyingListeners = !1);
  }, t.prototype._applyFingerprint = function(e) {
    e.fingerprint = e.fingerprint ? Array.isArray(e.fingerprint) ? e.fingerprint : [e.fingerprint] : [], this._fingerprint && (e.fingerprint = e.fingerprint.concat(this._fingerprint)), e.fingerprint && !e.fingerprint.length && delete e.fingerprint;
  }, t;
}();
function U_() {
  return Le("globalEventProcessors", function() {
    return [];
  });
}
var B_ = function() {
  function t(e) {
    this.errors = 0, this.sid = ot(), this.duration = 0, this.status = "ok", this.init = !0, this.ignoreDuration = !1;
    var r = Mr();
    this.timestamp = r, this.started = r, e && this.update(e);
  }
  return t.prototype.update = function(e) {
    if (e === void 0 && (e = {}), e.user && (!this.ipAddress && e.user.ip_address && (this.ipAddress = e.user.ip_address), !this.did && !e.did && (this.did = e.user.id || e.user.email || e.user.username)), this.timestamp = e.timestamp || Mr(), e.ignoreDuration && (this.ignoreDuration = e.ignoreDuration), e.sid && (this.sid = e.sid.length === 32 ? e.sid : ot()), e.init !== void 0 && (this.init = e.init), !this.did && e.did && (this.did = "" + e.did), typeof e.started == "number" && (this.started = e.started), this.ignoreDuration)
      this.duration = void 0;
    else if (typeof e.duration == "number")
      this.duration = e.duration;
    else {
      var r = this.timestamp - this.started;
      this.duration = r >= 0 ? r : 0;
    }
    e.release && (this.release = e.release), e.environment && (this.environment = e.environment), !this.ipAddress && e.ipAddress && (this.ipAddress = e.ipAddress), !this.userAgent && e.userAgent && (this.userAgent = e.userAgent), typeof e.errors == "number" && (this.errors = e.errors), e.status && (this.status = e.status);
  }, t.prototype.close = function(e) {
    e ? this.update({ status: e }) : this.status === "ok" ? this.update({ status: "exited" }) : this.update();
  }, t.prototype.toJSON = function() {
    return fe({
      sid: "" + this.sid,
      init: this.init,
      started: new Date(this.started * 1e3).toISOString(),
      timestamp: new Date(this.timestamp * 1e3).toISOString(),
      status: this.status,
      errors: this.errors,
      did: typeof this.did == "number" || typeof this.did == "string" ? "" + this.did : void 0,
      duration: this.duration,
      attrs: {
        release: this.release,
        environment: this.environment,
        ip_address: this.ipAddress,
        user_agent: this.userAgent
      }
    });
  }, t;
}(), Ur = typeof __SENTRY_DEBUG__ > "u" ? !0 : __SENTRY_DEBUG__, Fe = 4, G_ = 100, Ne = function() {
  function t(e, r, n) {
    r === void 0 && (r = new he()), n === void 0 && (n = Fe), this._version = n, this._stack = [{}], this.getStackTop().scope = r, e && this.bindClient(e);
  }
  return t.prototype.isOlderThan = function(e) {
    return this._version < e;
  }, t.prototype.bindClient = function(e) {
    var r = this.getStackTop();
    r.client = e, e && e.setupIntegrations && e.setupIntegrations();
  }, t.prototype.pushScope = function() {
    var e = he.clone(this.getScope());
    return this.getStack().push({
      client: this.getClient(),
      scope: e
    }), e;
  }, t.prototype.popScope = function() {
    return this.getStack().length <= 1 ? !1 : !!this.getStack().pop();
  }, t.prototype.withScope = function(e) {
    var r = this.pushScope();
    try {
      e(r);
    } finally {
      this.popScope();
    }
  }, t.prototype.getClient = function() {
    return this.getStackTop().client;
  }, t.prototype.getScope = function() {
    return this.getStackTop().scope;
  }, t.prototype.getStack = function() {
    return this._stack;
  }, t.prototype.getStackTop = function() {
    return this._stack[this._stack.length - 1];
  }, t.prototype.captureException = function(e, r) {
    var n = this._lastEventId = r && r.event_id ? r.event_id : ot(), i = r;
    if (!r) {
      var a = void 0;
      try {
        throw new Error("Sentry syntheticException");
      } catch (s) {
        a = s;
      }
      i = {
        originalException: e,
        syntheticException: a
      };
    }
    return this._invokeClient("captureException", e, b(b({}, i), { event_id: n })), n;
  }, t.prototype.captureMessage = function(e, r, n) {
    var i = this._lastEventId = n && n.event_id ? n.event_id : ot(), a = n;
    if (!n) {
      var s = void 0;
      try {
        throw new Error(e);
      } catch (o) {
        s = o;
      }
      a = {
        originalException: e,
        syntheticException: s
      };
    }
    return this._invokeClient("captureMessage", e, r, b(b({}, a), { event_id: i })), i;
  }, t.prototype.captureEvent = function(e, r) {
    var n = r && r.event_id ? r.event_id : ot();
    return e.type !== "transaction" && (this._lastEventId = n), this._invokeClient("captureEvent", e, b(b({}, r), { event_id: n })), n;
  }, t.prototype.lastEventId = function() {
    return this._lastEventId;
  }, t.prototype.addBreadcrumb = function(e, r) {
    var n = this.getStackTop(), i = n.scope, a = n.client;
    if (!(!i || !a)) {
      var s = a.getOptions && a.getOptions() || {}, o = s.beforeBreadcrumb, f = o === void 0 ? null : o, p = s.maxBreadcrumbs, d = p === void 0 ? G_ : p;
      if (!(d <= 0)) {
        var _ = yi(), g = b({ timestamp: _ }, e), S = f ? gi(function() {
          return f(g, r);
        }) : g;
        S !== null && i.addBreadcrumb(S, d);
      }
    }
  }, t.prototype.setUser = function(e) {
    var r = this.getScope();
    r && r.setUser(e);
  }, t.prototype.setTags = function(e) {
    var r = this.getScope();
    r && r.setTags(e);
  }, t.prototype.setExtras = function(e) {
    var r = this.getScope();
    r && r.setExtras(e);
  }, t.prototype.setTag = function(e, r) {
    var n = this.getScope();
    n && n.setTag(e, r);
  }, t.prototype.setExtra = function(e, r) {
    var n = this.getScope();
    n && n.setExtra(e, r);
  }, t.prototype.setContext = function(e, r) {
    var n = this.getScope();
    n && n.setContext(e, r);
  }, t.prototype.configureScope = function(e) {
    var r = this.getStackTop(), n = r.scope, i = r.client;
    n && i && e(n);
  }, t.prototype.run = function(e) {
    var r = Br(this);
    try {
      e(this);
    } finally {
      Br(r);
    }
  }, t.prototype.getIntegration = function(e) {
    var r = this.getClient();
    if (!r)
      return null;
    try {
      return r.getIntegration(e);
    } catch {
      return Ur && mt.warn("Cannot retrieve integration " + e.id + " from the current Hub"), null;
    }
  }, t.prototype.startSpan = function(e) {
    return this._callExtensionMethod("startSpan", e);
  }, t.prototype.startTransaction = function(e, r) {
    return this._callExtensionMethod("startTransaction", e, r);
  }, t.prototype.traceHeaders = function() {
    return this._callExtensionMethod("traceHeaders");
  }, t.prototype.captureSession = function(e) {
    if (e === void 0 && (e = !1), e)
      return this.endSession();
    this._sendSessionUpdate();
  }, t.prototype.endSession = function() {
    var e = this.getStackTop(), r = e && e.scope, n = r && r.getSession();
    n && n.close(), this._sendSessionUpdate(), r && r.setSession();
  }, t.prototype.startSession = function(e) {
    var r = this.getStackTop(), n = r.scope, i = r.client, a = i && i.getOptions() || {}, s = a.release, o = a.environment, f = M(), p = (f.navigator || {}).userAgent, d = new B_(b(b(b({
      release: s,
      environment: o
    }, n && { user: n.getUser() }), p && { userAgent: p }), e));
    if (n) {
      var _ = n.getSession && n.getSession();
      _ && _.status === "ok" && _.update({ status: "exited" }), this.endSession(), n.setSession(d);
    }
    return d;
  }, t.prototype._sendSessionUpdate = function() {
    var e = this.getStackTop(), r = e.scope, n = e.client;
    if (r) {
      var i = r.getSession && r.getSession();
      i && n && n.captureSession && n.captureSession(i);
    }
  }, t.prototype._invokeClient = function(e) {
    for (var r, n = [], i = 1; i < arguments.length; i++)
      n[i - 1] = arguments[i];
    var a = this.getStackTop(), s = a.scope, o = a.client;
    o && o[e] && (r = o)[e].apply(r, D(n, [s]));
  }, t.prototype._callExtensionMethod = function(e) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    var i = jt(), a = i.__SENTRY__;
    if (a && a.extensions && typeof a.extensions[e] == "function")
      return a.extensions[e].apply(this, r);
    Ur && mt.warn("Extension method " + e + " couldn't be found, doing nothing.");
  }, t;
}();
function jt() {
  var t = M();
  return t.__SENTRY__ = t.__SENTRY__ || {
    extensions: {},
    hub: void 0
  }, t;
}
function Br(t) {
  var e = jt(), r = L(e);
  return Me(e, t), r;
}
function z_() {
  var t = jt();
  return (!bi(t) || L(t).isOlderThan(Fe)) && Me(t, new Ne()), De() ? H_(t) : L(t);
}
function H_(t) {
  try {
    var e = jt().__SENTRY__, r = e && e.extensions && e.extensions.domain && e.extensions.domain.active;
    if (!r)
      return L(t);
    if (!bi(r) || L(r).isOlderThan(Fe)) {
      var n = L(t).getStackTop();
      Me(r, new Ne(n.client, he.clone(n.scope)));
    }
    return L(r);
  } catch {
    return L(t);
  }
}
function bi(t) {
  return !!(t && t.__SENTRY__ && t.__SENTRY__.hub);
}
function L(t) {
  return Le("hub", function() {
    return new Ne();
  }, t);
}
function Me(t, e) {
  if (!t)
    return !1;
  var r = t.__SENTRY__ = t.__SENTRY__ || {};
  return r.hub = e, !0;
}
function mi(t) {
  for (var e = [], r = 1; r < arguments.length; r++)
    e[r - 1] = arguments[r];
  var n = z_();
  if (n && n[t])
    return n[t].apply(n, D(e));
  throw new Error("No hub defined or " + t + " was not found on the hub, please open a bug report.");
}
function Ht(t, e) {
  var r = new Error("Sentry syntheticException");
  return mi("captureException", t, {
    captureContext: e,
    originalException: t,
    syntheticException: r
  });
}
function qt(t) {
  mi("withScope", t);
}
var _t = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function q_(t, e, r, n) {
  var i = -1, a = t == null ? 0 : t.length;
  for (n && a && (r = t[++i]); ++i < a; )
    r = e(r, t[i], i, t);
  return r;
}
var Y_ = q_;
function K_(t) {
  return function(e) {
    return t == null ? void 0 : t[e];
  };
}
var W_ = K_, V_ = W_, Z_ = {
  \u00C0: "A",
  \u00C1: "A",
  \u00C2: "A",
  \u00C3: "A",
  \u00C4: "A",
  \u00C5: "A",
  \u00E0: "a",
  \u00E1: "a",
  \u00E2: "a",
  \u00E3: "a",
  \u00E4: "a",
  \u00E5: "a",
  \u00C7: "C",
  \u00E7: "c",
  \u00D0: "D",
  \u00F0: "d",
  \u00C8: "E",
  \u00C9: "E",
  \u00CA: "E",
  \u00CB: "E",
  \u00E8: "e",
  \u00E9: "e",
  \u00EA: "e",
  \u00EB: "e",
  \u00CC: "I",
  \u00CD: "I",
  \u00CE: "I",
  \u00CF: "I",
  \u00EC: "i",
  \u00ED: "i",
  \u00EE: "i",
  \u00EF: "i",
  \u00D1: "N",
  \u00F1: "n",
  \u00D2: "O",
  \u00D3: "O",
  \u00D4: "O",
  \u00D5: "O",
  \u00D6: "O",
  \u00D8: "O",
  \u00F2: "o",
  \u00F3: "o",
  \u00F4: "o",
  \u00F5: "o",
  \u00F6: "o",
  \u00F8: "o",
  \u00D9: "U",
  \u00DA: "U",
  \u00DB: "U",
  \u00DC: "U",
  \u00F9: "u",
  \u00FA: "u",
  \u00FB: "u",
  \u00FC: "u",
  \u00DD: "Y",
  \u00FD: "y",
  \u00FF: "y",
  \u00C6: "Ae",
  \u00E6: "ae",
  \u00DE: "Th",
  \u00FE: "th",
  \u00DF: "ss",
  \u0100: "A",
  \u0102: "A",
  \u0104: "A",
  \u0101: "a",
  \u0103: "a",
  \u0105: "a",
  \u0106: "C",
  \u0108: "C",
  \u010A: "C",
  \u010C: "C",
  \u0107: "c",
  \u0109: "c",
  \u010B: "c",
  \u010D: "c",
  \u010E: "D",
  \u0110: "D",
  \u010F: "d",
  \u0111: "d",
  \u0112: "E",
  \u0114: "E",
  \u0116: "E",
  \u0118: "E",
  \u011A: "E",
  \u0113: "e",
  \u0115: "e",
  \u0117: "e",
  \u0119: "e",
  \u011B: "e",
  \u011C: "G",
  \u011E: "G",
  \u0120: "G",
  \u0122: "G",
  \u011D: "g",
  \u011F: "g",
  \u0121: "g",
  \u0123: "g",
  \u0124: "H",
  \u0126: "H",
  \u0125: "h",
  \u0127: "h",
  \u0128: "I",
  \u012A: "I",
  \u012C: "I",
  \u012E: "I",
  \u0130: "I",
  \u0129: "i",
  \u012B: "i",
  \u012D: "i",
  \u012F: "i",
  \u0131: "i",
  \u0134: "J",
  \u0135: "j",
  \u0136: "K",
  \u0137: "k",
  \u0138: "k",
  \u0139: "L",
  \u013B: "L",
  \u013D: "L",
  \u013F: "L",
  \u0141: "L",
  \u013A: "l",
  \u013C: "l",
  \u013E: "l",
  \u0140: "l",
  \u0142: "l",
  \u0143: "N",
  \u0145: "N",
  \u0147: "N",
  \u014A: "N",
  \u0144: "n",
  \u0146: "n",
  \u0148: "n",
  \u014B: "n",
  \u014C: "O",
  \u014E: "O",
  \u0150: "O",
  \u014D: "o",
  \u014F: "o",
  \u0151: "o",
  \u0154: "R",
  \u0156: "R",
  \u0158: "R",
  \u0155: "r",
  \u0157: "r",
  \u0159: "r",
  \u015A: "S",
  \u015C: "S",
  \u015E: "S",
  \u0160: "S",
  \u015B: "s",
  \u015D: "s",
  \u015F: "s",
  \u0161: "s",
  \u0162: "T",
  \u0164: "T",
  \u0166: "T",
  \u0163: "t",
  \u0165: "t",
  \u0167: "t",
  \u0168: "U",
  \u016A: "U",
  \u016C: "U",
  \u016E: "U",
  \u0170: "U",
  \u0172: "U",
  \u0169: "u",
  \u016B: "u",
  \u016D: "u",
  \u016F: "u",
  \u0171: "u",
  \u0173: "u",
  \u0174: "W",
  \u0175: "w",
  \u0176: "Y",
  \u0177: "y",
  \u0178: "Y",
  \u0179: "Z",
  \u017B: "Z",
  \u017D: "Z",
  \u017A: "z",
  \u017C: "z",
  \u017E: "z",
  \u0132: "IJ",
  \u0133: "ij",
  \u0152: "Oe",
  \u0153: "oe",
  \u0149: "'n",
  \u017F: "s"
}, J_ = V_(Z_), X_ = J_, Q_ = typeof _t == "object" && _t && _t.Object === Object && _t, Si = Q_, tv = Si, ev = typeof self == "object" && self && self.Object === Object && self, rv = tv || ev || Function("return this")(), P = rv, nv = P, iv = nv.Symbol, Pt = iv;
function av(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, i = Array(n); ++r < n; )
    i[r] = e(t[r], r, t);
  return i;
}
var sv = av, ov = Array.isArray, k = ov, Gr = Pt, xi = Object.prototype, uv = xi.hasOwnProperty, cv = xi.toString, it = Gr ? Gr.toStringTag : void 0;
function fv(t) {
  var e = uv.call(t, it), r = t[it];
  try {
    t[it] = void 0;
    var n = !0;
  } catch {
  }
  var i = cv.call(t);
  return n && (e ? t[it] = r : delete t[it]), i;
}
var pv = fv, hv = Object.prototype, lv = hv.toString;
function dv(t) {
  return lv.call(t);
}
var _v = dv, zr = Pt, vv = pv, gv = _v, yv = "[object Null]", bv = "[object Undefined]", Hr = zr ? zr.toStringTag : void 0;
function mv(t) {
  return t == null ? t === void 0 ? bv : yv : Hr && Hr in Object(t) ? vv(t) : gv(t);
}
var pt = mv;
function Sv(t) {
  return t != null && typeof t == "object";
}
var ht = Sv, xv = pt, Ev = ht, $v = "[object Symbol]";
function Av(t) {
  return typeof t == "symbol" || Ev(t) && xv(t) == $v;
}
var ke = Av, qr = Pt, wv = sv, Ov = k, Tv = ke, Cv = 1 / 0, Yr = qr ? qr.prototype : void 0, Kr = Yr ? Yr.toString : void 0;
function Ei(t) {
  if (typeof t == "string")
    return t;
  if (Ov(t))
    return wv(t, Ei) + "";
  if (Tv(t))
    return Kr ? Kr.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -Cv ? "-0" : e;
}
var jv = Ei, Pv = jv;
function Rv(t) {
  return t == null ? "" : Pv(t);
}
var Ue = Rv, Iv = X_, Dv = Ue, Lv = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Fv = "\\u0300-\\u036f", Nv = "\\ufe20-\\ufe2f", Mv = "\\u20d0-\\u20ff", kv = Fv + Nv + Mv, Uv = "[" + kv + "]", Bv = RegExp(Uv, "g");
function Gv(t) {
  return t = Dv(t), t && t.replace(Lv, Iv).replace(Bv, "");
}
var zv = Gv, Hv = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function qv(t) {
  return t.match(Hv) || [];
}
var Yv = qv, Kv = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function Wv(t) {
  return Kv.test(t);
}
var Vv = Wv, $i = "\\ud800-\\udfff", Zv = "\\u0300-\\u036f", Jv = "\\ufe20-\\ufe2f", Xv = "\\u20d0-\\u20ff", Qv = Zv + Jv + Xv, Ai = "\\u2700-\\u27bf", wi = "a-z\\xdf-\\xf6\\xf8-\\xff", tg = "\\xac\\xb1\\xd7\\xf7", eg = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rg = "\\u2000-\\u206f", ng = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Oi = "A-Z\\xc0-\\xd6\\xd8-\\xde", ig = "\\ufe0e\\ufe0f", Ti = tg + eg + rg + ng, Ci = "['\u2019]", Wr = "[" + Ti + "]", ag = "[" + Qv + "]", ji = "\\d+", sg = "[" + Ai + "]", Pi = "[" + wi + "]", Ri = "[^" + $i + Ti + ji + Ai + wi + Oi + "]", og = "\\ud83c[\\udffb-\\udfff]", ug = "(?:" + ag + "|" + og + ")", cg = "[^" + $i + "]", Ii = "(?:\\ud83c[\\udde6-\\uddff]){2}", Di = "[\\ud800-\\udbff][\\udc00-\\udfff]", Y = "[" + Oi + "]", fg = "\\u200d", Vr = "(?:" + Pi + "|" + Ri + ")", pg = "(?:" + Y + "|" + Ri + ")", Zr = "(?:" + Ci + "(?:d|ll|m|re|s|t|ve))?", Jr = "(?:" + Ci + "(?:D|LL|M|RE|S|T|VE))?", Li = ug + "?", Fi = "[" + ig + "]?", hg = "(?:" + fg + "(?:" + [cg, Ii, Di].join("|") + ")" + Fi + Li + ")*", lg = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", dg = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", _g = Fi + Li + hg, vg = "(?:" + [sg, Ii, Di].join("|") + ")" + _g, gg = RegExp([
  Y + "?" + Pi + "+" + Zr + "(?=" + [Wr, Y, "$"].join("|") + ")",
  pg + "+" + Jr + "(?=" + [Wr, Y + Vr, "$"].join("|") + ")",
  Y + "?" + Vr + "+" + Zr,
  Y + "+" + Jr,
  dg,
  lg,
  ji,
  vg
].join("|"), "g");
function yg(t) {
  return t.match(gg) || [];
}
var bg = yg, mg = Yv, Sg = Vv, xg = Ue, Eg = bg;
function $g(t, e, r) {
  return t = xg(t), e = r ? void 0 : e, e === void 0 ? Sg(t) ? Eg(t) : mg(t) : t.match(e) || [];
}
var Ag = $g, wg = Y_, Og = zv, Tg = Ag, Cg = "['\u2019]", jg = RegExp(Cg, "g");
function Pg(t) {
  return function(e) {
    return wg(Tg(Og(e).replace(jg, "")), t, "");
  };
}
var Rg = Pg, Ig = Rg, Dg = Ig(function(t, e, r) {
  return t + (r ? "_" : "") + e.toLowerCase();
}), Ni = Dg;
function Lg(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Be = Lg, Fg = pt, Ng = Be, Mg = "[object AsyncFunction]", kg = "[object Function]", Ug = "[object GeneratorFunction]", Bg = "[object Proxy]";
function Gg(t) {
  if (!Ng(t))
    return !1;
  var e = Fg(t);
  return e == kg || e == Ug || e == Mg || e == Bg;
}
var Mi = Gg, zg = P, Hg = zg["__core-js_shared__"], qg = Hg, Yt = qg, Xr = function() {
  var t = /[^.]+$/.exec(Yt && Yt.keys && Yt.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function Yg(t) {
  return !!Xr && Xr in t;
}
var Kg = Yg, Wg = Function.prototype, Vg = Wg.toString;
function Zg(t) {
  if (t != null) {
    try {
      return Vg.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var ki = Zg, Jg = Mi, Xg = Kg, Qg = Be, t0 = ki, e0 = /[\\^$.*+?()[\]{}|]/g, r0 = /^\[object .+?Constructor\]$/, n0 = Function.prototype, i0 = Object.prototype, a0 = n0.toString, s0 = i0.hasOwnProperty, o0 = RegExp(
  "^" + a0.call(s0).replace(e0, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function u0(t) {
  if (!Qg(t) || Xg(t))
    return !1;
  var e = Jg(t) ? o0 : r0;
  return e.test(t0(t));
}
var c0 = u0;
function f0(t, e) {
  return t == null ? void 0 : t[e];
}
var p0 = f0, h0 = c0, l0 = p0;
function d0(t, e) {
  var r = l0(t, e);
  return h0(r) ? r : void 0;
}
var H = d0, _0 = H, v0 = function() {
  try {
    var t = _0(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), g0 = v0, Qr = g0;
function y0(t, e, r) {
  e == "__proto__" && Qr ? Qr(t, e, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : t[e] = r;
}
var b0 = y0;
function m0(t) {
  return function(e, r, n) {
    for (var i = -1, a = Object(e), s = n(e), o = s.length; o--; ) {
      var f = s[t ? o : ++i];
      if (r(a[f], f, a) === !1)
        break;
    }
    return e;
  };
}
var S0 = m0, x0 = S0, E0 = x0(), $0 = E0;
function A0(t, e) {
  for (var r = -1, n = Array(t); ++r < t; )
    n[r] = e(r);
  return n;
}
var w0 = A0, O0 = pt, T0 = ht, C0 = "[object Arguments]";
function j0(t) {
  return T0(t) && O0(t) == C0;
}
var P0 = j0, tn = P0, R0 = ht, Ui = Object.prototype, I0 = Ui.hasOwnProperty, D0 = Ui.propertyIsEnumerable, L0 = tn(function() {
  return arguments;
}()) ? tn : function(t) {
  return R0(t) && I0.call(t, "callee") && !D0.call(t, "callee");
}, Bi = L0, St = { exports: {} };
function F0() {
  return !1;
}
var N0 = F0;
(function(t, e) {
  var r = P, n = N0, i = e && !e.nodeType && e, a = i && !0 && t && !t.nodeType && t, s = a && a.exports === i, o = s ? r.Buffer : void 0, f = o ? o.isBuffer : void 0, p = f || n;
  t.exports = p;
})(St, St.exports);
var M0 = 9007199254740991, k0 = /^(?:0|[1-9]\d*)$/;
function U0(t, e) {
  var r = typeof t;
  return e = e == null ? M0 : e, !!e && (r == "number" || r != "symbol" && k0.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var Gi = U0, B0 = 9007199254740991;
function G0(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= B0;
}
var Ge = G0, z0 = pt, H0 = Ge, q0 = ht, Y0 = "[object Arguments]", K0 = "[object Array]", W0 = "[object Boolean]", V0 = "[object Date]", Z0 = "[object Error]", J0 = "[object Function]", X0 = "[object Map]", Q0 = "[object Number]", ty = "[object Object]", ey = "[object RegExp]", ry = "[object Set]", ny = "[object String]", iy = "[object WeakMap]", ay = "[object ArrayBuffer]", sy = "[object DataView]", oy = "[object Float32Array]", uy = "[object Float64Array]", cy = "[object Int8Array]", fy = "[object Int16Array]", py = "[object Int32Array]", hy = "[object Uint8Array]", ly = "[object Uint8ClampedArray]", dy = "[object Uint16Array]", _y = "[object Uint32Array]", w = {};
w[oy] = w[uy] = w[cy] = w[fy] = w[py] = w[hy] = w[ly] = w[dy] = w[_y] = !0;
w[Y0] = w[K0] = w[ay] = w[W0] = w[sy] = w[V0] = w[Z0] = w[J0] = w[X0] = w[Q0] = w[ty] = w[ey] = w[ry] = w[ny] = w[iy] = !1;
function vy(t) {
  return q0(t) && H0(t.length) && !!w[z0(t)];
}
var gy = vy;
function yy(t) {
  return function(e) {
    return t(e);
  };
}
var by = yy, le = { exports: {} };
(function(t, e) {
  var r = Si, n = e && !e.nodeType && e, i = n && !0 && t && !t.nodeType && t, a = i && i.exports === n, s = a && r.process, o = function() {
    try {
      var f = i && i.require && i.require("util").types;
      return f || s && s.binding && s.binding("util");
    } catch {
    }
  }();
  t.exports = o;
})(le, le.exports);
var my = gy, Sy = by, en = le.exports, rn = en && en.isTypedArray, xy = rn ? Sy(rn) : my, zi = xy, Ey = w0, $y = Bi, Ay = k, wy = St.exports, Oy = Gi, Ty = zi, Cy = Object.prototype, jy = Cy.hasOwnProperty;
function Py(t, e) {
  var r = Ay(t), n = !r && $y(t), i = !r && !n && wy(t), a = !r && !n && !i && Ty(t), s = r || n || i || a, o = s ? Ey(t.length, String) : [], f = o.length;
  for (var p in t)
    (e || jy.call(t, p)) && !(s && (p == "length" || i && (p == "offset" || p == "parent") || a && (p == "buffer" || p == "byteLength" || p == "byteOffset") || Oy(p, f))) && o.push(p);
  return o;
}
var Ry = Py, Iy = Object.prototype;
function Dy(t) {
  var e = t && t.constructor, r = typeof e == "function" && e.prototype || Iy;
  return t === r;
}
var Ly = Dy;
function Fy(t, e) {
  return function(r) {
    return t(e(r));
  };
}
var Ny = Fy, My = Ny, ky = My(Object.keys, Object), Uy = ky, By = Ly, Gy = Uy, zy = Object.prototype, Hy = zy.hasOwnProperty;
function qy(t) {
  if (!By(t))
    return Gy(t);
  var e = [];
  for (var r in Object(t))
    Hy.call(t, r) && r != "constructor" && e.push(r);
  return e;
}
var Yy = qy, Ky = Mi, Wy = Ge;
function Vy(t) {
  return t != null && Wy(t.length) && !Ky(t);
}
var Zy = Vy, Jy = Ry, Xy = Yy, Qy = Zy;
function t1(t) {
  return Qy(t) ? Jy(t) : Xy(t);
}
var ze = t1, e1 = $0, r1 = ze;
function n1(t, e) {
  return t && e1(t, e, r1);
}
var i1 = n1;
function a1() {
  this.__data__ = [], this.size = 0;
}
var s1 = a1;
function o1(t, e) {
  return t === e || t !== t && e !== e;
}
var Hi = o1, u1 = Hi;
function c1(t, e) {
  for (var r = t.length; r--; )
    if (u1(t[r][0], e))
      return r;
  return -1;
}
var Rt = c1, f1 = Rt, p1 = Array.prototype, h1 = p1.splice;
function l1(t) {
  var e = this.__data__, r = f1(e, t);
  if (r < 0)
    return !1;
  var n = e.length - 1;
  return r == n ? e.pop() : h1.call(e, r, 1), --this.size, !0;
}
var d1 = l1, _1 = Rt;
function v1(t) {
  var e = this.__data__, r = _1(e, t);
  return r < 0 ? void 0 : e[r][1];
}
var g1 = v1, y1 = Rt;
function b1(t) {
  return y1(this.__data__, t) > -1;
}
var m1 = b1, S1 = Rt;
function x1(t, e) {
  var r = this.__data__, n = S1(r, t);
  return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
}
var E1 = x1, $1 = s1, A1 = d1, w1 = g1, O1 = m1, T1 = E1;
function X(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
X.prototype.clear = $1;
X.prototype.delete = A1;
X.prototype.get = w1;
X.prototype.has = O1;
X.prototype.set = T1;
var It = X, C1 = It;
function j1() {
  this.__data__ = new C1(), this.size = 0;
}
var P1 = j1;
function R1(t) {
  var e = this.__data__, r = e.delete(t);
  return this.size = e.size, r;
}
var I1 = R1;
function D1(t) {
  return this.__data__.get(t);
}
var L1 = D1;
function F1(t) {
  return this.__data__.has(t);
}
var N1 = F1, M1 = H, k1 = P, U1 = M1(k1, "Map"), He = U1, B1 = H, G1 = B1(Object, "create"), Dt = G1, nn = Dt;
function z1() {
  this.__data__ = nn ? nn(null) : {}, this.size = 0;
}
var H1 = z1;
function q1(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var Y1 = q1, K1 = Dt, W1 = "__lodash_hash_undefined__", V1 = Object.prototype, Z1 = V1.hasOwnProperty;
function J1(t) {
  var e = this.__data__;
  if (K1) {
    var r = e[t];
    return r === W1 ? void 0 : r;
  }
  return Z1.call(e, t) ? e[t] : void 0;
}
var X1 = J1, Q1 = Dt, tb = Object.prototype, eb = tb.hasOwnProperty;
function rb(t) {
  var e = this.__data__;
  return Q1 ? e[t] !== void 0 : eb.call(e, t);
}
var nb = rb, ib = Dt, ab = "__lodash_hash_undefined__";
function sb(t, e) {
  var r = this.__data__;
  return this.size += this.has(t) ? 0 : 1, r[t] = ib && e === void 0 ? ab : e, this;
}
var ob = sb, ub = H1, cb = Y1, fb = X1, pb = nb, hb = ob;
function Q(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
Q.prototype.clear = ub;
Q.prototype.delete = cb;
Q.prototype.get = fb;
Q.prototype.has = pb;
Q.prototype.set = hb;
var lb = Q, an = lb, db = It, _b = He;
function vb() {
  this.size = 0, this.__data__ = {
    hash: new an(),
    map: new (_b || db)(),
    string: new an()
  };
}
var gb = vb;
function yb(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var bb = yb, mb = bb;
function Sb(t, e) {
  var r = t.__data__;
  return mb(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
var Lt = Sb, xb = Lt;
function Eb(t) {
  var e = xb(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var $b = Eb, Ab = Lt;
function wb(t) {
  return Ab(this, t).get(t);
}
var Ob = wb, Tb = Lt;
function Cb(t) {
  return Tb(this, t).has(t);
}
var jb = Cb, Pb = Lt;
function Rb(t, e) {
  var r = Pb(this, t), n = r.size;
  return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
}
var Ib = Rb, Db = gb, Lb = $b, Fb = Ob, Nb = jb, Mb = Ib;
function tt(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
tt.prototype.clear = Db;
tt.prototype.delete = Lb;
tt.prototype.get = Fb;
tt.prototype.has = Nb;
tt.prototype.set = Mb;
var qe = tt, kb = It, Ub = He, Bb = qe, Gb = 200;
function zb(t, e) {
  var r = this.__data__;
  if (r instanceof kb) {
    var n = r.__data__;
    if (!Ub || n.length < Gb - 1)
      return n.push([t, e]), this.size = ++r.size, this;
    r = this.__data__ = new Bb(n);
  }
  return r.set(t, e), this.size = r.size, this;
}
var Hb = zb, qb = It, Yb = P1, Kb = I1, Wb = L1, Vb = N1, Zb = Hb;
function et(t) {
  var e = this.__data__ = new qb(t);
  this.size = e.size;
}
et.prototype.clear = Yb;
et.prototype.delete = Kb;
et.prototype.get = Wb;
et.prototype.has = Vb;
et.prototype.set = Zb;
var qi = et, Jb = "__lodash_hash_undefined__";
function Xb(t) {
  return this.__data__.set(t, Jb), this;
}
var Qb = Xb;
function tm(t) {
  return this.__data__.has(t);
}
var em = tm, rm = qe, nm = Qb, im = em;
function xt(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.__data__ = new rm(); ++e < r; )
    this.add(t[e]);
}
xt.prototype.add = xt.prototype.push = nm;
xt.prototype.has = im;
var am = xt;
function sm(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n; )
    if (e(t[r], r, t))
      return !0;
  return !1;
}
var om = sm;
function um(t, e) {
  return t.has(e);
}
var cm = um, fm = am, pm = om, hm = cm, lm = 1, dm = 2;
function _m(t, e, r, n, i, a) {
  var s = r & lm, o = t.length, f = e.length;
  if (o != f && !(s && f > o))
    return !1;
  var p = a.get(t), d = a.get(e);
  if (p && d)
    return p == e && d == t;
  var _ = -1, g = !0, S = r & dm ? new fm() : void 0;
  for (a.set(t, e), a.set(e, t); ++_ < o; ) {
    var x = t[_], E = e[_];
    if (n)
      var O = s ? n(E, x, _, e, t, a) : n(x, E, _, t, e, a);
    if (O !== void 0) {
      if (O)
        continue;
      g = !1;
      break;
    }
    if (S) {
      if (!pm(e, function(T, u) {
        if (!hm(S, u) && (x === T || i(x, T, r, n, a)))
          return S.push(u);
      })) {
        g = !1;
        break;
      }
    } else if (!(x === E || i(x, E, r, n, a))) {
      g = !1;
      break;
    }
  }
  return a.delete(t), a.delete(e), g;
}
var Yi = _m, vm = P, gm = vm.Uint8Array, ym = gm;
function bm(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n, i) {
    r[++e] = [i, n];
  }), r;
}
var mm = bm;
function Sm(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n) {
    r[++e] = n;
  }), r;
}
var xm = Sm, sn = Pt, on = ym, Em = Hi, $m = Yi, Am = mm, wm = xm, Om = 1, Tm = 2, Cm = "[object Boolean]", jm = "[object Date]", Pm = "[object Error]", Rm = "[object Map]", Im = "[object Number]", Dm = "[object RegExp]", Lm = "[object Set]", Fm = "[object String]", Nm = "[object Symbol]", Mm = "[object ArrayBuffer]", km = "[object DataView]", un = sn ? sn.prototype : void 0, Kt = un ? un.valueOf : void 0;
function Um(t, e, r, n, i, a, s) {
  switch (r) {
    case km:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case Mm:
      return !(t.byteLength != e.byteLength || !a(new on(t), new on(e)));
    case Cm:
    case jm:
    case Im:
      return Em(+t, +e);
    case Pm:
      return t.name == e.name && t.message == e.message;
    case Dm:
    case Fm:
      return t == e + "";
    case Rm:
      var o = Am;
    case Lm:
      var f = n & Om;
      if (o || (o = wm), t.size != e.size && !f)
        return !1;
      var p = s.get(t);
      if (p)
        return p == e;
      n |= Tm, s.set(t, e);
      var d = $m(o(t), o(e), n, i, a, s);
      return s.delete(t), d;
    case Nm:
      if (Kt)
        return Kt.call(t) == Kt.call(e);
  }
  return !1;
}
var Bm = Um;
function Gm(t, e) {
  for (var r = -1, n = e.length, i = t.length; ++r < n; )
    t[i + r] = e[r];
  return t;
}
var zm = Gm, Hm = zm, qm = k;
function Ym(t, e, r) {
  var n = e(t);
  return qm(t) ? n : Hm(n, r(t));
}
var Km = Ym;
function Wm(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, i = 0, a = []; ++r < n; ) {
    var s = t[r];
    e(s, r, t) && (a[i++] = s);
  }
  return a;
}
var Vm = Wm;
function Zm() {
  return [];
}
var Jm = Zm, Xm = Vm, Qm = Jm, tS = Object.prototype, eS = tS.propertyIsEnumerable, cn = Object.getOwnPropertySymbols, rS = cn ? function(t) {
  return t == null ? [] : (t = Object(t), Xm(cn(t), function(e) {
    return eS.call(t, e);
  }));
} : Qm, nS = rS, iS = Km, aS = nS, sS = ze;
function oS(t) {
  return iS(t, sS, aS);
}
var uS = oS, fn = uS, cS = 1, fS = Object.prototype, pS = fS.hasOwnProperty;
function hS(t, e, r, n, i, a) {
  var s = r & cS, o = fn(t), f = o.length, p = fn(e), d = p.length;
  if (f != d && !s)
    return !1;
  for (var _ = f; _--; ) {
    var g = o[_];
    if (!(s ? g in e : pS.call(e, g)))
      return !1;
  }
  var S = a.get(t), x = a.get(e);
  if (S && x)
    return S == e && x == t;
  var E = !0;
  a.set(t, e), a.set(e, t);
  for (var O = s; ++_ < f; ) {
    g = o[_];
    var T = t[g], u = e[g];
    if (n)
      var c = s ? n(u, T, g, e, t, a) : n(T, u, g, t, e, a);
    if (!(c === void 0 ? T === u || i(T, u, r, n, a) : c)) {
      E = !1;
      break;
    }
    O || (O = g == "constructor");
  }
  if (E && !O) {
    var l = t.constructor, h = e.constructor;
    l != h && "constructor" in t && "constructor" in e && !(typeof l == "function" && l instanceof l && typeof h == "function" && h instanceof h) && (E = !1);
  }
  return a.delete(t), a.delete(e), E;
}
var lS = hS, dS = H, _S = P, vS = dS(_S, "DataView"), gS = vS, yS = H, bS = P, mS = yS(bS, "Promise"), SS = mS, xS = H, ES = P, $S = xS(ES, "Set"), AS = $S, wS = H, OS = P, TS = wS(OS, "WeakMap"), CS = TS, de = gS, _e = He, ve = SS, ge = AS, ye = CS, Ki = pt, rt = ki, pn = "[object Map]", jS = "[object Object]", hn = "[object Promise]", ln = "[object Set]", dn = "[object WeakMap]", _n = "[object DataView]", PS = rt(de), RS = rt(_e), IS = rt(ve), DS = rt(ge), LS = rt(ye), B = Ki;
(de && B(new de(new ArrayBuffer(1))) != _n || _e && B(new _e()) != pn || ve && B(ve.resolve()) != hn || ge && B(new ge()) != ln || ye && B(new ye()) != dn) && (B = function(t) {
  var e = Ki(t), r = e == jS ? t.constructor : void 0, n = r ? rt(r) : "";
  if (n)
    switch (n) {
      case PS:
        return _n;
      case RS:
        return pn;
      case IS:
        return hn;
      case DS:
        return ln;
      case LS:
        return dn;
    }
  return e;
});
var FS = B, Wt = qi, NS = Yi, MS = Bm, kS = lS, vn = FS, gn = k, yn = St.exports, US = zi, BS = 1, bn = "[object Arguments]", mn = "[object Array]", vt = "[object Object]", GS = Object.prototype, Sn = GS.hasOwnProperty;
function zS(t, e, r, n, i, a) {
  var s = gn(t), o = gn(e), f = s ? mn : vn(t), p = o ? mn : vn(e);
  f = f == bn ? vt : f, p = p == bn ? vt : p;
  var d = f == vt, _ = p == vt, g = f == p;
  if (g && yn(t)) {
    if (!yn(e))
      return !1;
    s = !0, d = !1;
  }
  if (g && !d)
    return a || (a = new Wt()), s || US(t) ? NS(t, e, r, n, i, a) : MS(t, e, f, r, n, i, a);
  if (!(r & BS)) {
    var S = d && Sn.call(t, "__wrapped__"), x = _ && Sn.call(e, "__wrapped__");
    if (S || x) {
      var E = S ? t.value() : t, O = x ? e.value() : e;
      return a || (a = new Wt()), i(E, O, r, n, a);
    }
  }
  return g ? (a || (a = new Wt()), kS(t, e, r, n, i, a)) : !1;
}
var HS = zS, qS = HS, xn = ht;
function Wi(t, e, r, n, i) {
  return t === e ? !0 : t == null || e == null || !xn(t) && !xn(e) ? t !== t && e !== e : qS(t, e, r, n, Wi, i);
}
var Vi = Wi, YS = qi, KS = Vi, WS = 1, VS = 2;
function ZS(t, e, r, n) {
  var i = r.length, a = i, s = !n;
  if (t == null)
    return !a;
  for (t = Object(t); i--; ) {
    var o = r[i];
    if (s && o[2] ? o[1] !== t[o[0]] : !(o[0] in t))
      return !1;
  }
  for (; ++i < a; ) {
    o = r[i];
    var f = o[0], p = t[f], d = o[1];
    if (s && o[2]) {
      if (p === void 0 && !(f in t))
        return !1;
    } else {
      var _ = new YS();
      if (n)
        var g = n(p, d, f, t, e, _);
      if (!(g === void 0 ? KS(d, p, WS | VS, n, _) : g))
        return !1;
    }
  }
  return !0;
}
var JS = ZS, XS = Be;
function QS(t) {
  return t === t && !XS(t);
}
var Zi = QS, tx = Zi, ex = ze;
function rx(t) {
  for (var e = ex(t), r = e.length; r--; ) {
    var n = e[r], i = t[n];
    e[r] = [n, i, tx(i)];
  }
  return e;
}
var nx = rx;
function ix(t, e) {
  return function(r) {
    return r == null ? !1 : r[t] === e && (e !== void 0 || t in Object(r));
  };
}
var Ji = ix, ax = JS, sx = nx, ox = Ji;
function ux(t) {
  var e = sx(t);
  return e.length == 1 && e[0][2] ? ox(e[0][0], e[0][1]) : function(r) {
    return r === t || ax(r, t, e);
  };
}
var cx = ux, fx = k, px = ke, hx = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, lx = /^\w*$/;
function dx(t, e) {
  if (fx(t))
    return !1;
  var r = typeof t;
  return r == "number" || r == "symbol" || r == "boolean" || t == null || px(t) ? !0 : lx.test(t) || !hx.test(t) || e != null && t in Object(e);
}
var Ye = dx, Xi = qe, _x = "Expected a function";
function Ke(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(_x);
  var r = function() {
    var n = arguments, i = e ? e.apply(this, n) : n[0], a = r.cache;
    if (a.has(i))
      return a.get(i);
    var s = t.apply(this, n);
    return r.cache = a.set(i, s) || a, s;
  };
  return r.cache = new (Ke.Cache || Xi)(), r;
}
Ke.Cache = Xi;
var vx = Ke, gx = vx, yx = 500;
function bx(t) {
  var e = gx(t, function(n) {
    return r.size === yx && r.clear(), n;
  }), r = e.cache;
  return e;
}
var mx = bx, Sx = mx, xx = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ex = /\\(\\)?/g, $x = Sx(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(xx, function(r, n, i, a) {
    e.push(i ? a.replace(Ex, "$1") : n || r);
  }), e;
}), Ax = $x, wx = k, Ox = Ye, Tx = Ax, Cx = Ue;
function jx(t, e) {
  return wx(t) ? t : Ox(t, e) ? [t] : Tx(Cx(t));
}
var Qi = jx, Px = ke, Rx = 1 / 0;
function Ix(t) {
  if (typeof t == "string" || Px(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -Rx ? "-0" : e;
}
var Ft = Ix, Dx = Qi, Lx = Ft;
function Fx(t, e) {
  e = Dx(e, t);
  for (var r = 0, n = e.length; t != null && r < n; )
    t = t[Lx(e[r++])];
  return r && r == n ? t : void 0;
}
var ta = Fx, Nx = ta;
function Mx(t, e, r) {
  var n = t == null ? void 0 : Nx(t, e);
  return n === void 0 ? r : n;
}
var kx = Mx;
function Ux(t, e) {
  return t != null && e in Object(t);
}
var Bx = Ux, Gx = Qi, zx = Bi, Hx = k, qx = Gi, Yx = Ge, Kx = Ft;
function Wx(t, e, r) {
  e = Gx(e, t);
  for (var n = -1, i = e.length, a = !1; ++n < i; ) {
    var s = Kx(e[n]);
    if (!(a = t != null && r(t, s)))
      break;
    t = t[s];
  }
  return a || ++n != i ? a : (i = t == null ? 0 : t.length, !!i && Yx(i) && qx(s, i) && (Hx(t) || zx(t)));
}
var Vx = Wx, Zx = Bx, Jx = Vx;
function Xx(t, e) {
  return t != null && Jx(t, e, Zx);
}
var Qx = Xx, tE = Vi, eE = kx, rE = Qx, nE = Ye, iE = Zi, aE = Ji, sE = Ft, oE = 1, uE = 2;
function cE(t, e) {
  return nE(t) && iE(e) ? aE(sE(t), e) : function(r) {
    var n = eE(r, t);
    return n === void 0 && n === e ? rE(r, t) : tE(e, n, oE | uE);
  };
}
var fE = cE;
function pE(t) {
  return t;
}
var hE = pE;
function lE(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
var dE = lE, _E = ta;
function vE(t) {
  return function(e) {
    return _E(e, t);
  };
}
var gE = vE, yE = dE, bE = gE, mE = Ye, SE = Ft;
function xE(t) {
  return mE(t) ? yE(SE(t)) : bE(t);
}
var EE = xE, $E = cx, AE = fE, wE = hE, OE = k, TE = EE;
function CE(t) {
  return typeof t == "function" ? t : t == null ? wE : typeof t == "object" ? OE(t) ? AE(t[0], t[1]) : $E(t) : TE(t);
}
var jE = CE, PE = b0, RE = i1, IE = jE;
function DE(t, e) {
  var r = {};
  return e = IE(e), RE(t, function(n, i, a) {
    PE(r, e(n, i, a), n);
  }), r;
}
var LE = DE, G;
(function(t) {
  t.CLICK = "click", t.PAGEVIEW = "pageview", t.MODAL_VIEW = "modal-view", t.DEPTH = "depth", t.ERROR = "error", t.API = "api", t.EXPERIMENT = "experiment", t.ENTRY = "entry", t.SINGLE_PAGE_FLOW = "single-page-flow";
})(G || (G = {}));
class FE {
  constructor(e, r = []) {
    this.appName = e, this.externalSDKs = r;
  }
  identify(e, r) {
    this.externalSDKs.forEach((n) => {
      var i;
      try {
        (i = n()) == null || i.identify(e, r);
      } catch (a) {
        qt((s) => {
          s.setExtra("analytics-client", "Error identifying user"), Ht(a);
        });
      }
    });
  }
  track(e, r, n = {}) {
    this.externalSDKs.forEach((i) => {
      var a;
      try {
        (a = i()) == null || a.track(r, {
          event_title: e,
          event_type: r,
          app: this.appName,
          ...LE(n, (s, o) => Ni(o))
        });
      } catch (s) {
        qt((o) => {
          o.setExtra("analytics-client", "Error tracking event"), Ht(s);
        });
      }
    });
  }
  trackEvent({ eventName: e, eventType: r, eventProperties: n }) {
    this.track(e, r, n);
  }
  trackClick(e, r) {
    this.track(e, G.CLICK, r);
  }
  trackModalView(e, r) {
    this.track(e, G.MODAL_VIEW, r);
  }
  trackSinglePageFlow(e, r) {
    this.track(e, G.SINGLE_PAGE_FLOW, r);
  }
  reset() {
    this.externalSDKs.forEach((e) => {
      var r, n;
      try {
        (n = (r = e()) == null ? void 0 : r.reset) == null || n.call(r);
      } catch (i) {
        qt((a) => {
          a.setExtra("analytics-client", "Error reseting session"), Ht(i);
        });
      }
    });
  }
}
function NE(t, e) {
  function r() {
    const n = t(), i = An(e);
    return ia(() => {
      function a({ eventName: d, eventType: _, eventProperties: g = {} }) {
        n.trackEvent({
          eventName: d,
          eventType: _,
          eventProperties: {
            ...i,
            ...g
          }
        });
      }
      function s(d, _, g = {}) {
        n.track(d, _, {
          ...i,
          ...g
        });
      }
      function o(d, _ = {}) {
        n.trackClick(d, {
          ...i,
          ..._
        });
      }
      function f(d, _ = {}) {
        n.trackModalView(d, {
          ...i,
          ..._
        });
      }
      function p(d, _ = {}) {
        n.trackSinglePageFlow(d, {
          ...i,
          ..._
        });
      }
      return {
        EventType: G,
        trackEvent: a,
        track: s,
        trackClick: o,
        trackModalView: f,
        trackSinglePageFlow: p
      };
    }, [n, i]);
  }
  return r;
}
function ME(t) {
  return function() {
    const e = An(t);
    if (!e)
      throw new Error("Couldn't find an AnalyticsClient. Are you sure you configured an AnalyticsProvider with one?");
    return e;
  };
}
function kE(t) {
  return $n(t);
}
function UE() {
  const t = $n(null);
  return {
    AnalyticsClientContext: t,
    AnalyticsProvider: ({
      analyticsClient: e,
      children: r
    }) => ut(t.Provider, {
      value: e,
      children: r
    })
  };
}
function BE() {
  const t = kE({}), { AnalyticsProvider: e, AnalyticsClientContext: r } = UE(), n = ME(r), i = NE(n, t);
  return {
    AnalyticsPageContext: t,
    AnalyticsProvider: e,
    AnalyticsClientContext: r,
    useAnalyticsClient: n,
    useAnalytics: i
  };
}
const En = ["uuid", "id", "slug"];
function GE(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
const Vt = (t) => Ni(t);
function zE(t, e = []) {
  return Object.entries(t).reduce((r, [n, i]) => {
    if (e.includes(n))
      return {
        ...r,
        [Vt(n)]: "**redacted**"
      };
    let a = n, s = i;
    if (i !== null && typeof i == "object")
      for (let o = 0; o < En.length; o++) {
        const f = En[o];
        if (GE(i, f)) {
          a = `${n}_${f}`, s = i[f];
          break;
        }
      }
    return s == null || typeof s == "string" || typeof s == "number" || typeof s == "boolean" || s instanceof Date ? { ...r, [Vt(a)]: s } : {
      ...r,
      [Vt(a)]: `[${typeof s}]`
    };
  }, {});
}
const HE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  convertToSafeParams: zE
}, Symbol.toStringTag, { value: "Module" })), { AnalyticsPageContext: qE, AnalyticsProvider: t$, AnalyticsClientContext: e$, useAnalyticsClient: YE, useAnalytics: KE } = BE(), WE = {
  sent: {},
  ref: {},
  maxDepth: {}
};
function VE(t, e, r = WE) {
  const {
    pathName: n,
    pathPattern: i,
    exact: a
  } = t, {
    sent: s,
    ref: o,
    maxDepth: f
  } = r, p = i.split("/").length;
  if (s[n] === !0)
    return {
      dispatch: () => null,
      flush: () => null
    };
  o[n] = (o[n] || 0) + 1, a ? (s[n] = !0, e()) : f[n] = Math.max(f[n] || 0, p);
  function d() {
    !s[n] && f[n] === p && (e(), s[n] = !0);
  }
  let _ = !1;
  function g() {
    _ || (d(), o[n] = o[n] - 1, o[n] <= 0 && (delete o[n], delete s[n], delete f[n]), _ = !0);
  }
  return {
    dispatch: d,
    flush: g
  };
}
const r$ = ({
  analytics: t,
  analyticsPrivateStateParamKeys: e,
  ...r
}) => {
  var o;
  const n = ua(), i = YE(), [a, s] = aa({});
  return wn(() => {
    var O, T;
    const f = ca(n.pathname, {
      path: r.path,
      exact: r.exact
    });
    if (!f || !r.path) {
      In((u) => {
        u.setExtra("location.pathname", n.pathname), u.setExtra("path", r.path), u.setExtra("match", f), u.setLevel(te.Warning), Ca("No match or path was found when attempting to track pageview");
      });
      return;
    }
    const p = n.pathname, d = r.exact || f.url === p, _ = {
      ...typeof ((O = n.state) == null ? void 0 : O.searchParams) == "string" ? oe.parse(n.state.searchParams) : {},
      ...oe.parse(n.search)
    }, g = {
      ...Gt(t, (u, c) => Mt(c)),
      ...Gt(f.params, (u, c) => Mt(c)),
      ...Gt(_, (u, c) => Mt(c)),
      ...HE.convertToSafeParams((T = n.state) != null ? T : {}, e),
      search: n.search,
      page_name: t.pageName,
      path_name: p,
      path_pattern: r.path,
      path_pattern_exact: d
    };
    s(g);
    const S = {
      ...g,
      event_source: "autotrack"
    }, x = VE({
      pathName: S.path_name,
      pathPattern: S.path_pattern,
      exact: d
    }, () => i.track(t.pageName, G.PAGEVIEW, S)), E = setTimeout(x.dispatch, 200);
    return () => {
      clearTimeout(E), x.flush();
    };
  }, [i, t.pageName, n.pathname, n.search, (o = n.state) == null ? void 0 : o.searchParams, r.path, r.exact]), ut(qE.Provider, {
    value: a,
    children: ut(fa, {
      ...r
    })
  });
}, ZE = () => {
  const t = window;
  if (typeof t.freshpaint > "u") {
    In((e) => {
      e.setTag("FreshPaint", "Error initializing"), Ta("Freshpaint is undefined");
    });
    return;
  } else
    return t.freshpaint;
};
class n$ extends FE {
  constructor(e) {
    super(e, [ZE]), this.appName = e;
  }
}
function ea({
  eventName: t,
  eventProperties: e = {}
}, r) {
  const n = KE(), i = sa(null);
  return oa(r, () => i.current), wn(() => {
    const a = i.current;
    if (!a)
      return;
    const s = (o) => {
      var p;
      const f = o.currentTarget instanceof HTMLElement && (p = o.currentTarget.innerText) != null ? p : void 0;
      n.trackClick(t, {
        button_copy: f,
        ...e
      });
    };
    return a.addEventListener("click", s), () => {
      a.removeEventListener("click", s);
    };
  }), i;
}
const i$ = at.forwardRef(({
  children: t,
  ...e
}, r) => {
  const n = ea(e, r);
  if (at.Children.count(t) > 1 || !at.isValidElement(t)) {
    if (process.env.NODE_ENV === "production")
      return ut(na, {
        children: t
      });
    throw new Error("Only one child is supported within the TrackClick component");
  }
  return at.cloneElement(t, {
    ref: n
  });
});
function a$(t) {
  return at.forwardRef(({
    eventName: e,
    eventProperties: r,
    ...n
  }, i) => {
    const a = ea({
      eventName: e,
      eventProperties: r
    }, i);
    return ut(t, {
      ...n,
      ref: a
    });
  });
}
export {
  n$ as AnalyticsClient,
  e$ as AnalyticsClientContext,
  G as AnalyticsEventType,
  qE as AnalyticsPageContext,
  t$ as AnalyticsProvider,
  r$ as Route,
  i$ as TrackClick,
  ZE as getGlobalFreshpaint,
  VE as queueEvent,
  KE as useAnalytics,
  YE as useAnalyticsClient,
  a$ as withClickTracking
};
//# sourceMappingURL=web-analytics.es.js.map
